import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import {FormBuilder,  FormGroup,  FormsModule, Validators ,FormControl} from '@angular/forms';
import { ExcelServiceHeader } from '../../utils/excel.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { ActivatedRoute } from '@angular/router';
import { MatSelect } from '@angular/material/select';
import { CartaPorteDetalle } from '../../models/cartaPorte';
import { FacturaItem } from '../../models/facturaItem';


@Component({
    selector: 'my-carta-porte',
    templateUrl: 'carta-porte.component.html',
    styleUrls: ['carta-porte.component.scss'],
    providers: [generalService, ExcelServiceHeader]
})

export class CartaPorte  implements OnInit {
    
    constructor(public dataService: DataService,
        public _generalService: generalService,
        private formBuilder: FormBuilder,
        private fb: FormBuilder, 
        public dialog: MatDialog, 
        private route: ActivatedRoute,
        ) {
    }

    cartaPorteAdd: FormGroup;

    public seEstaEditando = false;
    public seEstaAgregando = false;
    //servcios
    public seEstaEditando1 = false;
    public seEstaAgregando1 = false;
    //ubicaciones
    public seEstaEditando2 = false;
    public seEstaAgregando2 = false;
    //trasporte
    public seEstaEditando3 = false;
    public seEstaAgregando3 = false;

    public opcionSeleccinada = '';
    public opcionSeleccinadaEdit = '';
    
    public validarOrigenDestino = true;

    public edicionBorrar = false;
    private formularioValido = true;
    public btnSigiente = true;
    public btnSigienteServicios = true;
    public btnValidarUbucaciones = true;
    public btnDeleteUbicaiones = false;
    
    public ValidacionOrigenDestino = false;
    public btnGuardar = true;

    //formulario
    public seEstaAgregandoDetallePeso = false;
    public seEstaAgregandoDetalleServicios = false
    public seEstaAgregandoUbicaciones = false
    public seEstaAgregandoTraporte = false
    //pantallas
    public datosGeneralesSeguros = true;
    public detallePesoCraga = false;
    public detalleServicios = false;
    public ubicaciones = false;
    public figuraTrasporte = false;

    public transaccionEnCurso = false;
    inputDisable = true

    public dataSource = new MatTableDataSource<CartaPorteDetalle>();
    listaCartaPorteDetalle: CartaPorteDetalle[] = [];
    listaCartaPorteDetalle_SR: CartaPorteDetalle[] = [];
    listaCartaPorteDetalle_U: CartaPorteDetalle[] = [];
    listaCartaPorteDetalle_Ubicaciones_Aux: CartaPorteDetalle[] = [];
    listaCartaPorteDetalle_T: CartaPorteDetalle[] = [];
    listaCartaPorteAgregar: CartaPorteDetalle[] = [];
    public dataSource01 = new MatTableDataSource<CartaPorteDetalle>();
    public dataSource02 = new MatTableDataSource<CartaPorteDetalle>();
    
    public dataSource03 = new MatTableDataSource<CartaPorteDetalle>();

    //Data DB 
    public listaDataVehiculo: any[] = [];
    public listaVehiculo: any[] = [];
    public listaProductos: any[] = [];
    public listaProductosServicios: any[] = [];
    public listaUnidad: any[] = [];
    public listaSATCode: any[] = [];
    
    
    public listaProductosAUX: any[] = [];
    public listaServicios: any[] = [];
    public listaTransporte: any []=[];
    public listamaterialesPeligrosos:any [] = [];
    public listaembalaje:any [] = [];
    public listaMoneda:any [] = [];
    public listaCartaPorte:any [] = [];
    public listaubicacionesEliminadas:any [] = [];
    public listaCartaPorteDetallePesoCarga:any [] = [];
    public listaCartaPorteDetallePesoCargaFactura:any [] = [];
         public listaProductosFactura:any [] = [];
    //public listaCartaPorteDetalleServicos:any [] = [];
    public listaCartaPorteDetalleTrasporte:any [] = [];
    public listaCartaPorteDetalleUbicaciones:any [] = [];
    public listaCartaPorteDetalleOrigenDestino:any [] = [];
    public lista_ar_company:any [] = [];
    public lista_company_address:any [] = [];
    public lista_ar_customer:any [] = [];
    public lista_customer_address:any [] = [];
    
    private itemsShowProd = 10;
    public listaConfiguracionVehicular: any[] = [];
    public listaProductosDPC :any [] = [];

    modelIdVehiculo: any = "";
    modelProductoAgregando: any = [];
    modelProductoServicio: any = [];
    modelTrasporte :any = [];

    //edit
    public editarCartaPorte = false;
    public btnName = 'Guardar'
    public idCartaPorte = 0;
    public msjSatisfaction ='El registro se guardo exitosamente!'
    
    public viewDataProd: any[];
    public viewDataProdEdit: any[];
    public viewDataProdServicio: any[];
    public viewDataProdEditServicio: any[];
    @ViewChild('infiniteSelect') selectElem: MatSelect;

    public viewDataSat: any[];
    public viewDataSatEdit: any[];

    private arrayFilteredProd = undefined;
    private arrayFilteredProdSer = undefined;
    private filteredItemsShowProd = 10;
    private isFilteredProd = false;
    

    public ID_origendestino  = '';
    public IdCCP = '';

   // @ViewChild('infiniteSelectSat') selectElemSat: MatSelect;


    public displayedColumnsPesoCarga: string[] = [
        'acciones',
        'producto',
        'satID',
        'cantidad',
        'unidad',
        'pesoBrutoTotal',
        'pesoNetoTotal',
        'cargoTasación',
        'dimensiones',
        'MaterialPeligroso',
        'materialPeligrosoClave',
        'embalaje',
        'IdOrigen',
        'IdDestino'
    ];
    //  public displayedColumnsservicios: string[] = [
        //'acciones',
        //'productoServicios',
        //'bienesTrasportados',
        //'claveSTCC',
        //'descripcion',
        //'cantidad',
        //'claveUnidad',
        //'unidad',
        //'dimensiones',
        //'materialPeligroso',
        //'claveMaterialPeligroso',
        //'embalaje',
        //'descripcionEmbalaje',
        //'pesoKG',
        //'valorMercancia',
        //'importe',
        //'moneda',
        //'fraccionArancelaria',
        //'UUID'
    //];
    public displayedColumnsFiguraTrasporte: string[] = [
        'acciones',
        'operadorid',
        'numeroLicencia',
        //'tipoFugura',
        'tipoFugura_name',
        'RFCFigura',
        'pais',
        //'CityId',
        'CPFiguraTrasporte',
        'estadoFiguraTrasporte',
        'municipioFiguraTrasporte',
        'coloniaFiguraTrasporte',
        'calleFiguraTrasporte',
        'numExteriorFiguraTrasporte',
        'numInteriorFiguraTrasporte',
        'referenciaFiguraTrasporte'
    ]
    public displayedColumnsUbicaciones : string [] = [
        'acciones',
        'IdOrDe',
       'tipoUbicacion',
       'ubicaciones',
       'fechaHora',
       //'salidaLegada',
       'RFCUbicacion',
       'distanciaRecorrida',
       'paisUbicacion',
       //'C_LOCALIDAD',
       'C_LOCALIDAD_Value',
       'CPUbicacion',
       'estadoUbicacion',
       'municipioUbicacion',
      // 'CYTI_ID',
       'coloniaUbicacion',
       'calleUbicacion',
       'numExterioUbicacion',
       'numInteriorUbicacion',
        'referenciaUbicacion',
    ]
    
    public cartaPorteDetalle: CartaPorteDetalle =  new CartaPorteDetalle();
      //  ------------------ FORM Ubicaciones---------------------------
    listaDetalleCartePorte_Ubicacion: CartaPorteDetalle[] = [];
    public UbicacionesControl = new FormControl(null, [Validators.required]);
    public tipoubicacionControl = new FormControl(null, [Validators.required]);
    public RFCUbicacionControl = new FormControl({ value: null, disabled: true }, [Validators.required]);
    public fechaHoraControl = new FormControl(null, [Validators.required]);
    public salidaLlegadaControl = new FormControl(null);
    public distanciaRecorridaControl = new FormControl(null, [Validators.required]);
    public paisUbicacionControl = new FormControl({ value: null, disabled: true }, [Validators.required]);
    public C_LOCALIDADControl = new FormControl({ value: null, disabled: true }, [Validators.required]);
    public C_LOCALIDAD_ValueControl = new FormControl({ value: null, disabled: true }, [Validators.required]);
    public CPUbicacionControl = new FormControl({ value: null, disabled: true }, [Validators.required]);
    public estadoUbicacionControl = new FormControl({ value: null, disabled: true }, [Validators.required]);
    public municipioUbicacionControl = new FormControl({ value: null, disabled: true });
    public CYTI_ID_contol = new FormControl (null);
    public coloniaUbicacionControl = new FormControl({ value: null, disabled: true });
    public calleUbicacionControl = new FormControl({ value: null, disabled: true });
    public numExterioUbicacionControl = new FormControl({ value: null, disabled: true });
    public numInteriorUbicacionControl = new FormControl({ value: null, disabled: true });
    public referenciaUbicacionControl = new FormControl(null);
    public IDorigendestino = new FormControl ({ value: null, disabled: true });
    public commentsUbicacionesControl = new FormControl(null)
    tiposUbicaciones =[
        {BILL_CARTA_PORTE_TYPE: 'O', value: 'Origen'},
        {BILL_CARTA_PORTE_TYPE: 'D', value: 'Destino'}
    ]
    public selectUbicaciones: any[] = [];
    public UbicacionesCompañia: any[] = [];
    public UbicacionesCliente: any[] = [];
    public listOrigen: any[] = [];
    public listDestino: any[] = [];
    
    //  ------------------ FORM Figura Trasporte---------------------------
    listaDetalleCartePorte_Trasporte: CartaPorteDetalle[] = [];
    public operadoridControl = new FormControl(null, [Validators.required]);
    public numeroLicenciaControl = new FormControl({ value: null, disabled: true }, [Validators.required]);
    public RFCFiguraControl = new FormControl({ value: null, disabled: true }, [Validators.required]);
    public paisTrasporteControl = new FormControl({ value: null, disabled: true }, [Validators.required]);
    public CITYIDTrasporteControl = new FormControl(null);
    public CPFiguraTrasporteControl = new FormControl({ value: null, disabled: true }, [Validators.required]);
    public municipioFiguraTrasporteControl = new FormControl({ value: null, disabled: true });
    public estadoFiguraTrasporteControl = new FormControl({ value: null, disabled: true }, [Validators.required]);
    public coloniaFiguraTrasporteControl = new FormControl({ value: null, disabled: true });
    public calleFiguraTrasporteControl = new FormControl({ value: null, disabled: true });
    public numExteriorFiguraTrasporteControl = new FormControl({ value: null, disabled: true });
    public numInteriorFiguraTrasporteControl = new FormControl({ value: null, disabled: true });
    public referenciaFiguraTrasporteControl = new FormControl({ value: null, disabled: true });
    public tipoFiguraTrasporteControl = new FormControl({ value: null, disabled: true });
    public tipoFigura_Name_TrasporteControl = new FormControl({ value: null, disabled: true });
    
    //  ------------------ FORM Detalle Peso Carga---------------------------
    
    materialPeligrosoOption  =[
        {CLAVEMATERIALPELIGROSO_DPC: 0, value:  'No'},
        {CLAVEMATERIALPELIGROSO_DPC: 1, value: 'Si'}
    ]
    listaDetalleCartePorte_PesoCarga: CartaPorteDetalle[] = [];
    listaDetalleCartePorte_PesoCargaAux: CartaPorteDetalle[] = [];
    public pesoBrutoTotalControl = new FormControl(null, [Validators.required]);
    public unidadPesoControl = new FormControl(null, [Validators.required]);
    public ProductoControl = new FormControl(null, [Validators.required]);
    public pesoNetoTotalControl = new FormControl(null);
    public cantidadPesoCargaControl = new FormControl(null, [Validators.required]);
    public cargoTasacionControl = new FormControl(null);
    public commentsConceptosControl = new FormControl(null);
    public dimensionesControl_detallePesoCarga = new FormControl(null);
    public materialPeligrosoControl_DPC = new FormControl({ value: null, disabled: true });
    public claveMaterialPeligrosoControl_DPC  = new FormControl(null, [Validators.required]);
    public embalajeControl_DPC  = new FormControl({ value: null, disabled: true });
    public satIDPesoControl  = new FormControl(null, [Validators.required]);
    public IdOrigenPesoControl  = new FormControl(null, [Validators.required]);
    public IdDestinonPesoControl  = new FormControl(null, [Validators.required]);
    
    
    
    public descripcionControl = new FormControl(null, [Validators.required]);
    //  ------------------ FORM Servicios---------------------------
    // listaDetalleCartePorte_Servicios: CartaPorteDetalle[] = [];
    // public bienesTrasportadosControl = new FormControl(null);
    // public claveSTCCControl = new FormControl(null); 
    // public cantidadControl = new FormControl(null, [Validators.required]);
    // public claveUnidadControl = new FormControl(null);
    // public unidadControl = new FormControl(null);
    // public ProductoControlServicios = new FormControl(null);
    // public dimensionesControl = new FormControl(null);
    // public materialPeligrosoControl = new FormControl(null);
    // public claveMaterialPeligrosoControl = new FormControl(null);
    // public embalajeControl = new FormControl(null);
    // public descripcionEmbalajeControl = new FormControl(null);
    // public pesoKGControl = new FormControl(null);
    // public valorMercanciaControl = new FormControl(null,[Validators.required]);
    // public monedaControl = new FormControl(null);
    // public fraccionArancelariaControl = new FormControl(null);
    // public UUIDControl = new FormControl(null);
    //public importeControl = new FormControl({ value: null, disabled: true });
    
      
    
//-------------------------------------------------------------General--------------------------------

    ngOnInit() {
    // Inicializa tu formulario reactivo
    this.cartaPorteAdd = this.fb.group({
      vehiculo: [null, Validators.required], 
     
     configuracionVehicular: [{ value: null, disabled: true }, Validators.required],
     tipoPermisoSCT: [{ value: null, disabled: true }, Validators.required],
     aseguradoraRFC: [{ value: null, disabled: true }, Validators.required],
     polizaRFC: [{ value: null, disabled: true }, Validators.required],
     anioModeloVM: [{ value: null, disabled: true }, Validators.required],
     numeroPermisoSCT: [{ value: null, disabled: true }, Validators.required],
     placaVM: [{ value: null, disabled: true }, Validators.required],
     pesoBruto: [{ value: null, disabled: true }, Validators.required],
    
    });
    this.getIdCCP();
    this.getData();
    this.getCartaPorteDetalle(this.dataSource);
    this.getOrigenDestino();
    
    }    

    cerrarModal() {
        this.dataService.dialogRef.close();
    }
    
    onKeyUpProd(val: any) {
        let arr: any[];
        if (val.currentTarget.value != "") {
          this.arrayFilteredProd = this.listaProductos.filter((obj) => {
            return obj.NAME_PRODUCT.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
          })

          arr = this.arrayFilteredProd.slice(0, this.filteredItemsShowProd);
          this.isFilteredProd = true;
          
        } else {
          /***************************INFINITE SELECT**********************************/
        
          this.isFilteredProd = false;
          this.filteredItemsShowProd = 10;
          this.arrayFilteredProd = undefined;
          arr = this.listaProductos;
          /***************************INFINITE SELECT**********************************/
        }
        /***************************INFINITE SELECT**********************************/
        if(this.detallePesoCraga){
            if(this.seEstaEditando) {
                this.viewDataProdEdit = arr;
            } else {
                this.viewDataProd = arr;
            }
        }
    }

    // onKeyUpProdServicos(val: any) {
    //     let arr: any[];
    //     if (val.currentTarget.value != "") {
    //       this.arrayFilteredProdSer = this.listaProductosServicios.filter((obj) => {
    //         return obj.NAME_PRODUCT.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
    //       })

    //       arr = this.arrayFilteredProdSer.slice(0, this.filteredItemsShowProd);
    //       this.isFilteredProd = true;
          
    //     } else {
    //       /***************************INFINITE SELECT**********************************/
        
    //       this.isFilteredProd = false;
    //       this.filteredItemsShowProd = 10;
    //       this.arrayFilteredProdSer = undefined;
    //       arr = this.listaProductosServicios;
    //       /***************************INFINITE SELECT**********************************/
    //     }
    //     /***************************INFINITE SELECT**********************************/
    //     if(this.detalleServicios){
    //         if(this.seEstaEditando1) {
    //             this.viewDataProdEditServicio = arr;
    //         } else {
    //             this.viewDataProdServicio = arr;
    //         }
    //     }
    // }
    
    
    setAccionAgregar(value:number) {
        this.edicionBorrar = true;
        this.establecerValoresPorDefectoDetallePeso();
       // this.establecerValoresDefectosDetalleServicios();
        this.establecerValoresDefectosUbicaciones();
        this.establecerValoresPorDefectosTrasporte();
        this.modelProductoAgregando;
        switch(value){
            case 1:    
                this.cantidad ="";
                this.seEstaEditando = false;
                this.seEstaAgregando = true; 
                this.seEstaAgregandoDetallePeso = true;
                this.IdOrigenPesoControl.setValue(this.listOrigen[0]['BILL_CARTA_PORTE_ADDRESS_ID']);
                this.IdDestinonPesoControl.setValue(this.listDestino[0]['BILL_CARTA_PORTE_ADDRESS_ID']);
                //this.camposOrigenDestino();          
            break;
            case 2:
                this.seEstaAgregandoDetalleServicios = true;
                this.seEstaEditando1 = false;
                this.seEstaAgregando1 = true;
            break;
            case 3:
                this.seEstaAgregandoUbicaciones = true;
                this.seEstaEditando2 = false;
                this.seEstaAgregando2 = true;
                this.selectUbicaciones=[];
                
            break;
            case 4:
                this.seEstaAgregandoTraporte = true;
                this.seEstaEditando3 = false;
                this.seEstaAgregando3 = true;
            break;
        }
        
    }
    cancelarAccion(value:number) {
        this.edicionBorrar = false;
        switch(value){
            case 1:
                this.establecerValoresPorDefectoDetallePeso();
                this.cantidad ="";
            break;
            // case 2:
            //    this.establecerValoresDefectosDetalleServicios();
            // break;
            case 3:
                this.establecerValoresDefectosUbicaciones();
            break;
            case 4:
                this.establecerValoresPorDefectosTrasporte();
            break; 
        }
            
    }
    nexPage(value:number){
        //muestra las secciones
        switch(value){
            case 1:
                this.datosGeneralesSeguros = false; 
                //this.detalleServicios = true; 
                 this.ubicaciones = true;
            break;
            case 2:
                this.detalleServicios = false;
               //this.ubicaciones = true;
               this.edicionBorrar = false;
            break;
            case 3:
                this.btnDeleteUbicaiones = true;
                this.ubicaciones = false;
                this.detallePesoCraga = true;
                this.edicionBorrar = false;
                this.guardarCartaPorte(1);               
            break;
            case 4:
                if(!this.editarCartaPorte){
                    this.validarSiguientePesoCarga();
                }else{
                    this.detallePesoCraga = false;
                    this.figuraTrasporte = true;
                    this.edicionBorrar = false;
                }
                
            break; 
            case 5:
                this.detallePesoCraga = true;
                this.figuraTrasporte = false;
                this.edicionBorrar = false;
            break; 
            case 6:
                this.ubicaciones = true;
                this.detallePesoCraga = false;
                this.edicionBorrar = false;
                this.getCartaPorteDetalle(this.dataSource);
                this.validarOrigenDestino = true;
            break;
            case 7:
                //this.detalleServicios = true;
               this.ubicaciones = false;
               this.edicionBorrar = false;
               this.datosGeneralesSeguros = true;
               
            break;
            case 8:
                this.datosGeneralesSeguros = true; 
                this.detalleServicios = false;
            break;
        }   
    }
    onSubmit() {}

    //obtener datos DB
    getData(){
        let metodo = 'factura/getDataCartaPorte';
        const params = {
            BILL_ID: this.dataService.dialogRef._containerInstance._config.data.BILL_ID, 
            loacs: sessionStorage.getItem('acslo')
        };

        this._generalService.metodoCallParams(params, metodo).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                this.listaVehiculo = tableResult.Table;

                this.listaProductos =  tableResult.Table1;
                this.viewDataProd = this.listaProductos;
                this.viewDataProdEdit = this.viewDataProd;

                this.listaTransporte = tableResult.Table2;
                this.listamaterialesPeligrosos = tableResult.Table3;
                this.listaembalaje = tableResult.Table4;
                this.listaMoneda = tableResult.Table5;
                this.listaCartaPorte = tableResult.Table6;
                this.lista_ar_company = tableResult.Table7;
                this.lista_company_address = tableResult.Table8;
                this.lista_ar_customer = tableResult.Table9;
                this.lista_customer_address = tableResult.Table10;
                this.listaUnidad = tableResult.Table11;
                this.listaSATCode = tableResult.Table12;
                this.viewDataSat = this.listaSATCode.slice(0, this.itemsShowProd);

                this.listaProductosServicios = tableResult.Table13;
                this.viewDataProdServicio = this.listaProductosServicios;
                this.viewDataProdEditServicio = this.viewDataProdServicio;
                

                if(this.listaCartaPorte.length > 0){
                    this.idCartaPorte = this.listaCartaPorte[0].BILL_CARTA_PORTE_ID;
                    this.btnName = 'Actualizar'
                    this.editarCartaPorte = true;
                }    
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );
    }

    getOrigenDestino(){
        this.listaDetalleCartePorte_PesoCargaAux = [];
        let metodo = 'factura/getDataOrigenDestino';
        const params = {
            BILL_ID: this.dataService.dialogRef._containerInstance._config.data.BILL_ID, 
            loacs: sessionStorage.getItem('acslo'),
            CartaPorte_ID: this.idCartaPorte,
        };

        this._generalService.metodoCallParams(params, metodo).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                this.listaDetalleCartePorte_PesoCargaAux = tableResult.Table;
                this.camposOrigenDestino();
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );
    }
    
    
    //enviar datos back
    guardarCartaPorte(opcion:number){
        let metodo = 'factura/addCartaPorte';
        
        const params = {
           
            //cartaPorteDetalleServicios: this.dataSource01.filteredData,
            cartaPorteDetalleUbicacion: this.dataSource02.filteredData,
            cartaPorteDetallePesoCarga: this.dataSource.filteredData,
            cartaPorteDetalleTrasporte: this.dataSource03.filteredData,
            cartaPorteDetalle: this.cartaPorteAdd.value.vehiculo,
            loacs: sessionStorage.getItem('acslo'),
            BILL_ID: this.dataService.dialogRef._containerInstance._config.data.BILL_ID,
            CartaPorte_ID: this.idCartaPorte,
            BILLTYPE: this.dataService.dialogRef._containerInstance._config.data.BILL_TYPE,
            opcion:opcion,
            IdCCP:this.IdCCP

        };

        if(this.editarCartaPorte){ 
            metodo = 'factura/editCartaPorte';
            this.msjSatisfaction ='El registro se actualizo exitosamente!'
           
        }
       
        this._generalService.metodoCallParams(params, metodo).subscribe(
            (result) => {
                //this.getData();
                //this.getCartaPorteDetalle(this.dataSource02);
                if(opcion == 2){
                    this.cerrarModal();
                    setTimeout(() => {
                        this._generalService.toastCall(this.msjSatisfaction);
                    }, 600); 
                }else{
                    setTimeout(() => {
                        this.validarOrigenDestino = false;
                        this.getOrigenDestino();
                        this.setValueCartaPorteDetalle();
                    }, 600);

                }
                
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );
    }

    getIdCCP(){
        this.IdCCP = '';
        this._generalService.requestGet('helperSAT/getIdCCP').subscribe(
            (result) => {
                this.IdCCP = JSON.parse(result);
                
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );
    }
    

    //Datos Genarales
    
    onChangedValueDG(){
        //this.cartaPorteAdd.get('numeroPermisoSCT').value();
        this.cartaPorteAdd.get('numeroPermisoSCT').setValue(this.modelIdVehiculo.NUMERO_PERMISO_SCT);
        this.cartaPorteAdd.get('placaVM').setValue(this.modelIdVehiculo.PLACA_VM);
        this.cartaPorteAdd.get('anioModeloVM').setValue(this.modelIdVehiculo.MODELO);
        this.cartaPorteAdd.get('polizaRFC').setValue(this.modelIdVehiculo.POLIZA_RC);
        this.cartaPorteAdd.get('aseguradoraRFC').setValue(this.modelIdVehiculo.ASEGURADORA_RC);
        this.cartaPorteAdd.get('tipoPermisoSCT').setValue(this.modelIdVehiculo.TIPO_PERMISO);
        this.cartaPorteAdd.get('configuracionVehicular').setValue(this.modelIdVehiculo.CONFIGURACION_VEHICULAR);
        this.cartaPorteAdd.get('pesoBruto').setValue(this.modelIdVehiculo.PESO_BRUTO);
        
    }

    getCartaPorteDetalle(id: any){
        this.listaCartaPorteDetalle = [];
        this.listaCartaPorteDetalle_SR = [];
        this.listaCartaPorteDetalle_T = [];
        this.listaCartaPorteDetalle_U =[];
        let metodo = 'factura/getDetalleCartaPorte';
        const params = {
            
            BILL_ID: this.dataService.dialogRef._containerInstance._config.data.BILL_ID, 
            loacs: sessionStorage.getItem('acslo')
        };

        this._generalService.metodoCallParams(params, metodo).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                this.listaCartaPorte = tableResult.Table;
                this.listaCartaPorteDetallePesoCarga = tableResult.Table1;
                //this.listaCartaPorteDetalleServicos = tableResult.Table2;
                this.listaCartaPorteDetalleTrasporte = tableResult.Table3;
                this.listaCartaPorteDetalleUbicaciones = tableResult.Table4;
                this.listaCartaPorteDetallePesoCargaFactura = tableResult.Table5;
                this.listaProductosFactura = tableResult.Table6;
                

               
                if( this.listaCartaPorte.length > 0){
                  
                    // Detalles de Carta Porte
                    if (this.listaCartaPorte.length > 0){
                        this.cartaPorteAdd.get('vehiculo').setValue(this.listaCartaPorte[0].VehicleName)
                        this.cartaPorteAdd.get('numeroPermisoSCT').setValue(this.listaCartaPorte[0].NUMERO_PERMISO_SCT);
                        this.cartaPorteAdd.get('placaVM').setValue(this.listaCartaPorte[0].PLACA_VM);
                        this.cartaPorteAdd.get('anioModeloVM').setValue(this.listaCartaPorte[0].MODELO);
                        this.cartaPorteAdd.get('pesoBruto').setValue(this.listaCartaPorte[0].PESO_BRUTO);
                        this.cartaPorteAdd.get('polizaRFC').setValue(this.listaCartaPorte[0].POLIZA_RC);
                        this.cartaPorteAdd.get('aseguradoraRFC').setValue(this.listaCartaPorte[0].ASEGURADORA_RC);
                        this.cartaPorteAdd.get('tipoPermisoSCT').setValue(this.listaCartaPorte[0].TIPO_PERMISO_SCT);
                        this.cartaPorteAdd.get('configuracionVehicular').setValue(this.listaCartaPorte[0].CONFIGURACION_VEHICULAR);      
                    }  
                    
                    // Detalles de lista Detalle PesoCarga


                    
                    if (this.listaCartaPorteDetallePesoCarga.length > 0) {
                        this.listaCartaPorteDetalle = [];
                        for (let i = 0; i < this.listaCartaPorteDetallePesoCarga.length; i++) {
                            this.listaCartaPorteDetallePesoCarga[i].index = i;

                            //this.cartaPorteDetalle.IdOrigen_DPC = this.IdOrigenPesoControl.value;
                            var origenDetalle = "";
                            const or = this.listOrigen.find((e) => e.BILL_CARTA_PORTE_ADDRESS_ID === this.listaCartaPorteDetallePesoCarga[i]['IdOrigen_DPC']);
                            if (or !== null && or !== undefined){
                                origenDetalle = or.Name_origendestino;
                            
                            } 
                            
                            const modeloAuxiliar: any = {
                                
                                index: i,
                                BILL_CARTA_PORTE_WEIGHT_DETAIL_ID:  this.listaCartaPorteDetallePesoCarga[i].BILL_CARTA_PORTE_WEIGHT_DETAIL_ID,
                                PRODUCTO_DPC: this.listaCartaPorteDetallePesoCarga[i].PRODUCTO_DPC,
                                UNIDAD_PESO_DPC: this.listaCartaPorteDetallePesoCarga[i].UNIDAD_PESO_DPC,
                                PESO_BRUTO_TOTAL_DPC: this.listaCartaPorteDetallePesoCarga[i].PESO_BRUTO_TOTAL_DPC,
                                PESO_NETO_DPC: this.listaCartaPorteDetallePesoCarga[i].PESO_NETO_DPC,
                                cantidad_DPC: this.listaCartaPorteDetallePesoCarga[i].cantidad_DPC,
                                Cargo_Tasacion_DPC: this.listaCartaPorteDetallePesoCarga[i].Cargo_Tasacion_DPC,
                                ITEM_ID: this.listaCartaPorteDetallePesoCarga[i].ITEM_ID,
                                BILL_UNIT_MEASURE_ID: this.listaCartaPorteDetallePesoCarga[i].BILL_UNIT_MEASURE_ID,
                                satID: this.listaCartaPorteDetallePesoCarga[i].satID,
                                DIMENSIONES_DPC: this.listaCartaPorteDetallePesoCarga[i].DIMENSIONES_DPC,
                                MATERIALPELIGROSO_DPC:this.listaCartaPorteDetallePesoCarga[i].MATERIALPELIGROSO_DPC ,
                                CLAVEMATERIALPELIGROSO_DPC: this.listaCartaPorteDetallePesoCarga[i].CLAVEMATERIALPELIGROSO_DPC,
                                CLAVEMATERIALPELIGROSO_DPC_aux: this.listaCartaPorteDetallePesoCarga[i].HAZARDOUS_MATERIAL,
                                EMBALAJE_DPC:this.listaCartaPorteDetallePesoCarga[i].EMBALAJE_DPC,
                                ITEM_SAT_ID:this.listaCartaPorteDetallePesoCarga[i].ITEM_SAT_ID,
                                BILL_PACKAGING_ID:this.listaCartaPorteDetallePesoCarga[i].BILL_PACKAGING_ID,
                                HAZARDOUS_MATERIAL:this.listaCartaPorteDetallePesoCarga[i].HAZARDOUS_MATERIAL,
                                HAZARDOUS_MATERIAL_ID:this.listaCartaPorteDetallePesoCarga[i].HAZARDOUS_MATERIAL_ID,
                                IdOrigen_DPC:this.listaCartaPorteDetallePesoCarga[i].IdOrigen_DPC,
                                IdDestino_DPC:this.listaCartaPorteDetallePesoCarga[i].IdDestino_DPC,
                                IdOrigen_DPC_id:this.listaCartaPorteDetallePesoCarga[i].IdOrigen_DPC,
                                IdDestino_DPC_id:this.listaCartaPorteDetallePesoCarga[i].IdDestino_DPC,
                                
                            };
                            this.listaCartaPorteDetalle.push(modeloAuxiliar);   
                        }
                
                        this.dataSource.data = this.listaCartaPorteDetalle;

                        if (this.dataSource.data.length > 0) {
                            this.btnSigienteServicios = false;
                        }
                        

                    }else{
                        this.dataSource.data= this.listaCartaPorteDetalle = [];
                        this.btnSigienteServicios = true;
                    }
                    
             
                    // if(this.listaCartaPorteDetalleServicos.length > 0){
                        
                    //     for (let i = 0; i < this.listaCartaPorteDetalleServicos.length; i++) {
                    //         this.listaCartaPorteDetalleServicos[i].index = i;
                            
                    //         const modeloAuxiliarServicos: any = {
                                
                    //             index: i,
                    //             BILL_CARTA_PORTE_SERVICES_DETAIL_ID: this.listaCartaPorteDetalleServicos[i].BILL_CARTA_PORTE_SERVICES_DETAIL_ID,
                    //             BIENES_TRASPORTADOS_SR : this.listaCartaPorteDetalleServicos[i].BIENES_TRASPORTADOS_SR,
                    //             BILL_PACKAGING_ID : this.listaCartaPorteDetalleServicos[i].BILL_PACKAGING_ID,
                    //             EMBALAJE_SR : this.listaCartaPorteDetalleServicos[i].EMBALAJE_SR,
                    //             BILL_UNIT_MEASURE_ID : this.listaCartaPorteDetalleServicos[i].BILL_UNIT_MEASURE_ID,
                    //             UNIDAD_SR : this.listaCartaPorteDetalleServicos[i].UNIDAD_SR,
                    //             CLAVE_STC_SR : this.listaCartaPorteDetalleServicos[i].CLAVE_STC_SR,
                    //             CURRENCY_ID : this.listaCartaPorteDetalleServicos[i].CURRENCY_ID,
                    //             MONEDA_SR : this.listaCartaPorteDetalleServicos[i].MONEDA_SR,
                    //             DESCRIPCION_SR : this.listaCartaPorteDetalleServicos[i].DESCRIPCION_SR,
                    //             DIMENSIONES_SR : this.listaCartaPorteDetalleServicos[i].DIMENSIONES_SR,
                    //             HAZARDOUS_MATERIAL : this.listaCartaPorteDetalleServicos[i].HAZARDOUS_MATERIAL,
                    //             HAZARDOUS_MATERIAL_ID: this.listaCartaPorteDetalleServicos[i].HAZARDOUS_MATERIAL_ID,
                    //             MATERIALPELIGROSO_SR: this.listaCartaPorteDetalleServicos[i].MATERIALPELIGROSO_SR,
                    //             ITEM_ID : this.listaCartaPorteDetalleServicos[i].ITEM_ID,
                                
                    //             PRODUCTO_SR : this.listaCartaPorteDetalleServicos[i].PRODUCTO_SR,
                    //             DESCRIPCIONEMBALAJE_SR : this.listaCartaPorteDetalleServicos[i].DESCRIPCIONEMBALAJE_SR,
                    //             CANTIDAD_SR : this.listaCartaPorteDetalleServicos[i].CANTIDAD_SR,
                    //             FRACCION_ARANCELARIA_SR : this.listaCartaPorteDetalleServicos[i].FRACCION_ARANCELARIA_SR,
                    //             CLAVEUNIDAD_SR: this.listaCartaPorteDetalleServicos[i].CLAVEUNIDAD_SR,
                    //             VALOR_MERCANCIA_SR: this.listaCartaPorteDetalleServicos[i].VALOR_MERCANCIA_SR,
                    //             UUID_SR : this.listaCartaPorteDetalleServicos[i].UUID_SR,
                    //             AMOUNT: this.listaCartaPorteDetalleServicos[i].AMOUNT,

                    //         };
                    //         this.listaCartaPorteDetalle_SR.push(modeloAuxiliarServicos);

                    //         this.dataSource01.data = this.listaCartaPorteDetalle_SR;

                    //         if (this.dataSource01.data.length > 0) {
                    //             this.btnSigiente = false;
                    //         }

                           
                            
                    //     }
                    // }else{
                    //     this.listaCartaPorteDetalle_SR;
                    //     this.listaDetalleCartePorte_Servicios;
                    //     this.dataSource01.data= this.listaCartaPorteDetalle_SR = [];
                    //     this.btnSigiente = true;
                    // }

                    // Detalles de lista Trasporte 
                    if (this.listaCartaPorteDetalleTrasporte.length > 0) {
                        this.listaCartaPorteDetalle_T = [];
                        
                        for (let i = 0; i < this.listaCartaPorteDetalleTrasporte.length; i++) {
                            this.listaCartaPorteDetalleTrasporte[i].index = i;
                            
                            const modeloAuxiliarTrasporte: any = {
                                
                                index: i,
                                BILL_CARTA_PORTE_DRIVER_ID :  this.listaCartaPorteDetalleTrasporte[i].BILL_CARTA_PORTE_DRIVER_ID,
                                BILL_CARTA_PORTE_ID : this.listaCartaPorteDetalleTrasporte[i].BILL_CARTA_PORTE_ID,
                                DRIVER_ID: this.listaCartaPorteDetalleTrasporte[i].DRIVER_ID,
                                //OPERADOR_T: this.listaCartaPorteDetalleTrasporte[i].DRIVER_ID,
                                NUMERO_LICENCIA_TPE: this.listaCartaPorteDetalleTrasporte[i].NUMERO_LICENCIA_TPE,
                                RFC_FIGURA_TPE: this.listaCartaPorteDetalleTrasporte[i].RFC_FIGURA_TPE,
                                CP_FIGURA_TPE: this.listaCartaPorteDetalleTrasporte[i].CP_FIGURA_TPE,
                                CITY_ID_TPE: this.listaCartaPorteDetalleTrasporte[i].CITY_ID,
                                COLONIA_TPE: this.listaCartaPorteDetalleTrasporte[i].COLONIA_TPE,
                                CALLE_TPE: this.listaCartaPorteDetalleTrasporte[i].CALLE_TPE,
                                NUM_EXTERIOR_TPE: this.listaCartaPorteDetalleTrasporte[i].NUM_EXTERIOR_TPE,
                                NUM_INTERIOR_TPE: this.listaCartaPorteDetalleTrasporte[i].NUM_INTERIOR_TPE,
                                REFERENCIA_TPE: this.listaCartaPorteDetalleTrasporte[i].REFERENCIA_TPE,
                                OPERADOR_T : this.listaCartaPorteDetalleTrasporte[i].OPERADOR_T,
                                NAME_CITY: this.listaCartaPorteDetalleTrasporte[i].NAME_CITY,
                                MUNICIPI_TPE: this.listaCartaPorteDetalleTrasporte[i].MUNICIPI_TPE,
                                ESTADO_TPE : this.listaCartaPorteDetalleTrasporte[i].ESTADO_TPE,
                                PAIS_TPE: this.listaCartaPorteDetalleTrasporte[i].PAIS_TPE,
                                TIPO_Name_TPE: this.listaCartaPorteDetalleTrasporte[i].TIPO_Name_TPE,
                                TIPO_TPE: this.listaCartaPorteDetalleTrasporte[i].SAT_FIGURE_TYPE_ID,
                                SAT_FIGURE_TYPE_ID: this.listaCartaPorteDetalleTrasporte[i].SAT_FIGURE_TYPE_ID
                            };


                            this.listaCartaPorteDetalle_T.push(modeloAuxiliarTrasporte);
                            
                        }
                
                        this.dataSource03.data = this.listaCartaPorteDetalle_T;

                        if (this.dataSource03.data.length > 0) {
                            this.btnGuardar = false;
                        }
                    }else{
                        this.dataSource03.data= this.listaCartaPorteDetalle_T = [];
                        this.btnGuardar = true;
                    }

                    // Detalles de lista Ubicaciones
                    if (this.listaCartaPorteDetalleUbicaciones.length > 0) {
                        this.listaCartaPorteDetalle_U = [];
                        //const listaDetallePesoCargaAux: any[] = [];
                        let contadorO = 0;
                        let contadorD = 0;
                        
                        for (let i = 0; i < this.listaCartaPorteDetalleUbicaciones.length; i++) {
                            this.listaCartaPorteDetalleUbicaciones[i].index = i; 


                            //--------------------------------
                            
                            let  opcionOD = "";
                    
                            
                                if ( this.listaCartaPorteDetalleUbicaciones[i]['TIPO_UBICACION_opcion'] === 'O') {
                                    contadorO++;
                                    opcionOD = 'OR'  + contadorO.toString().padStart(6, '0');
                                    
                                }
                                if (this.listaCartaPorteDetalleUbicaciones[i]['TIPO_UBICACION_opcion'] === 'D') {
                                    contadorD++;
                                    opcionOD = 'DE' + contadorD.toString().padStart(6, '0');
                                }
                               
                           
                            if(contadorO >= 1 && contadorD>= 1){
                                this.btnValidarUbucaciones = false;
                            }
                            //-------------------------
                             
                            //this.ID_origendestino  = opcionOD;
                            this.listaCartaPorteDetalleUbicaciones[i].ID_origendestino = opcionOD;
                            const modeloAuxiliarUbicaciones: any = {
                                
                                index: i,
                                ID_origendestino:opcionOD,
                                
                                BILL_CARTA_PORTE_ADDRESS_ID: this.listaCartaPorteDetalleUbicaciones[i].BILL_CARTA_PORTE_ADDRESS_ID,
                                BILL_CARTA_PORTE_ID: this.listaCartaPorteDetalleUbicaciones[i].BILL_CARTA_PORTE_ID,                    
                                CUSTOMER_ADDRESS_ID: this.listaCartaPorteDetalleUbicaciones[i].CUSTOMER_ADDRESS_ID,
                                COMPANY_ADDRESS_ID: this.listaCartaPorteDetalleUbicaciones[i].COMPANY_ADDRESS_ID,
                                BILL_CARTA_PORTE_TYPE: this.listaCartaPorteDetalleUbicaciones[i].BILL_CARTA_PORTE_TYPE,
                                TIPO_UBICACION_opcion: this.listaCartaPorteDetalleUbicaciones[i].TIPO_UBICACION_opcion,
                                UBICACIONES_UBICACION_number: this.listaCartaPorteDetalleUbicaciones[i].CUSTOMER_ADDRESS_ID == null ?
                                    this.listaCartaPorteDetalleUbicaciones[i].COMPANY_ADDRESS_ID :
                                    this.listaCartaPorteDetalleUbicaciones[i].CUSTOMER_ADDRESS_ID,
                                UBICACIONES_UBICACION : this.listaCartaPorteDetalleUbicaciones[i].UBICACIONES_UBICACION,
                                CITY_ID: this.listaCartaPorteDetalleUbicaciones[i].CITY_ID,
                                RFC_UBICACION: this.listaCartaPorteDetalleUbicaciones[i].RFC_UBICACION,
                                COLONIA_UBICACION: this.listaCartaPorteDetalleUbicaciones[i].COLONIA_UBICACION,
                                CALLE_UBICACION: this.listaCartaPorteDetalleUbicaciones[i].CALLE_UBICACION,
                                DISTANCIA_RECORRIDA_UBICACION: this.listaCartaPorteDetalleUbicaciones[i].DISTANCIA_RECORRIDA_UBICACION,
                                NUM_EXTERIO_UBICACION: this.listaCartaPorteDetalleUbicaciones[i].NUM_EXTERIO_UBICACION,
                                NUM_INTERIOR_UBICACION: this.listaCartaPorteDetalleUbicaciones[i].NUM_INTERIOR_UBICACION,
                                CP_UBICACION: this.listaCartaPorteDetalleUbicaciones[i].CP_UBICACION,
                                REFERENCIA_UBICACION: this.listaCartaPorteDetalleUbicaciones[i].REFERENCIA_UBICACION,
                                MUNICIPIO_UBICACION: this.listaCartaPorteDetalleUbicaciones[i].MUNICIPIO_UBICACION,
                                ESTADO_UBICACION: this.listaCartaPorteDetalleUbicaciones[i].ESTADO_UBICACION,
                                PAIS_UBICACION: this.listaCartaPorteDetalleUbicaciones[i].PAIS_UBICACION,
                                FECHAHORA_UBICACION: this.listaCartaPorteDetalleUbicaciones[i].FECHAHORA_UBICACION,
                                C_LOCALIDAD_Value: this.listaCartaPorteDetalleUbicaciones[i].C_LOCALIDAD_Value,
                                C_LOCALIDAD: this.listaCartaPorteDetalleUbicaciones[i].LOCATION_ID
                                
                            };

                           
                            this.listaCartaPorteDetalle_U.push(modeloAuxiliarUbicaciones);
                            
 
                        }
                
                        this.dataSource02.data = this.listaCartaPorteDetalle_U;
                        if (this.dataSource02.data.length == 1) {
                            this.btnValidarUbucaciones = true;
                        }

                    }else{
                        this.dataSource02.data= this.listaCartaPorteDetalle_U = [];
                        this.btnValidarUbucaciones = true;
                    }

                }else{
                    //this.validaProductosFactura();
                   
                }  
                this.btnDeleteUbicaiones = false;
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );

    }

    validaProductosFactura() {
        const indexSet = new Set<number>(); // Conjunto para almacenar índices
    
        if (this.listaCartaPorteDetallePesoCargaFactura.length > 0) {
            this.listaCartaPorteDetalle = []; // Limpiar la lista antes de agregar elementos
            this.listaProductosFactura;
            
            for (let i = 0; i < this.listaCartaPorteDetallePesoCargaFactura.length; i++) {
                this.listaCartaPorteDetallePesoCargaFactura[i].index = i;
    
                const index = i;
    
                // Verificar si el índice ya existe en el conjunto
                if (!indexSet.has(index)) {
                    indexSet.add(index);

                
                    const DetallePesoCargaFactura: any = {
                        index: index,
                        PRODUCTO_DPC: this.listaCartaPorteDetallePesoCargaFactura[i].PRODUCTO_DPC,
                        QUANTITY: this.listaCartaPorteDetallePesoCargaFactura[i].QUANTITY,
                        cantidad_DPC: this.listaCartaPorteDetallePesoCargaFactura[i].cantidad_DPC,
                        ITEM_ID: this.listaCartaPorteDetallePesoCargaFactura[i].ITEM_ID,
                        ITEM_SAT_ID:this.listaCartaPorteDetallePesoCargaFactura[i].ITEM_SAT_ID,
                        satID:this.listaCartaPorteDetallePesoCargaFactura[i].satID,
                        UNIDAD_PESO_DPC:this.listaCartaPorteDetallePesoCargaFactura[i].UNIDAD_PESO_DPC,
                        UNIT_MEASURE_ID:this.listaCartaPorteDetallePesoCargaFactura[i].UNIT_MEASURE_ID,
                        //BILL_UNIT_MEASURE_ID: this.listaCartaPorteDetallePesoCargaFactura[i].BILL_UNIT_MEASURE_ID,
                        
                        satID_id:this.listaCartaPorteDetallePesoCargaFactura[i].ITEM_SAT_ID
                    
                    };
    
                    this.listaCartaPorteDetalle.push(DetallePesoCargaFactura);
                }
            }
    
            this.dataSource.data = this.listaCartaPorteDetalle;
    
            if (this.dataSource.data.length > 0) {
                this.btnSigienteServicios = false;
            }
    
        } else {
            this.dataSource.data = this.listaCartaPorteDetalle = [];
            this.btnSigienteServicios = true;
        }
    }

    //-------------------------------------------------------------PesoCarga--------------------------------
    cantidad: string = ''; // Variable para almacenar la cantidad
    pesoBruto: number = 0;
    pesoNeto: number = 0;
    pesoBrutoOriginal = 0;
    pesoNetoOriginal = 0;
    cantidadAnteriro = 0;
    recalculo = false;
    calculoPesoBrutoPesoNeto(val: any,) {
        let valor = val.key;
        let bandera = false;
        let recalculoPesoBruto
        let recalculoPesoNeto
        

        if (!isNaN(Number(valor))) { // Verifica si el valor es un número
            this.cantidad += valor; // Concatena el valor numérico a la variable cantidad
        }else if (valor === 'Backspace') { // Verifica si se presionó la tecla de retroceso
            this.cantidad = this.cantidad.slice(0, -1); // Elimina el último carácter de cantidad
            bandera = true;
        }
        

        let cantidadNumero: number = parseInt(this.cantidad);

        this.pesoBruto == 0 || this.pesoBruto  == null  ? this.pesoBruto = this.pesoBrutoTotalControl.value : this.pesoBruto = this.pesoBruto
        this.pesoNeto == 0 || this.pesoNeto  == null ?  this.pesoNeto = this.pesoNetoTotalControl.value : this.pesoNeto = this.pesoNeto
      
        if(!bandera){
            this.cantidadAnteriro = cantidadNumero
        }

       
             
       
        recalculoPesoBruto = this.pesoBrutoOriginal * cantidadNumero;
        recalculoPesoNeto = this.pesoNetoOriginal * cantidadNumero;
        
       

        if (isNaN(cantidadNumero) || cantidadNumero === 0) {
            recalculoPesoBruto = this.pesoBrutoOriginal;
            }

        if (isNaN(cantidadNumero) || cantidadNumero === 0) {
            recalculoPesoNeto = this.pesoNetoOriginal;
            }

        this.pesoBrutoTotalControl.setValue(recalculoPesoBruto);
        this.pesoNetoTotalControl.setValue(recalculoPesoNeto);
       
        this.pesoBruto = 0;
        this.pesoNeto = 0;
        recalculoPesoBruto = 0;
        recalculoPesoNeto = 0;
 
    }
    validarSiguientePesoCarga() {
    
        let cantidadAguardar = 0;
        let index = 0;
        let falloGrid = false;
        let stringError = '';
        this.listaCartaPorteDetalle.forEach((element) => {
            index++;
            if (element) {
                if (element.UNIDAD_PESO_DPC === null || element.UNIDAD_PESO_DPC === undefined ) {
                  
                    stringError += 'Error Renglón ' + index + ' La Unidad es requerida, ';
                    falloGrid = true;
                }
                if (element.satID_id === null || element.satID_id === undefined ) {
                   
                     stringError += 'Error Renglón ' + index + ' La Cve. Prod. o Servicio es requerida, ';
                     falloGrid = true;
                
                }
                if (element.PESO_BRUTO_TOTAL_DPC === null || element.PESO_BRUTO_TOTAL_DPC === undefined ) {
                   
                     stringError += 'Error Renglón ' + index + ' El Peso Bruto  es requerido, ';
                     falloGrid = true;
                
                }
                if (element.cantidad_DPC === null || element.cantidad_DPC === undefined ) {
                   
                     stringError += 'Error Renglón ' + index + ' La Cantidad es requerida, ';
                     falloGrid = true;
                
                }
                if (element.CLAVEMATERIALPELIGROSO_DPC === null || element.CLAVEMATERIALPELIGROSO_DPC === undefined ) {
                    
                     stringError += 'Error Renglón ' + index + ' El Material Peligros es requerid, ';
                     falloGrid = true;
                
                }
                if (element.IdOrigen_DPC_id === null || element.IdOrigen_DPC_id === undefined ) {
                  
                     stringError += 'Error Renglón ' + index + ' El origen es requerido, ';
                     falloGrid = true;
                
                }
                if (element.IdDestino_DPC_id === null || element.IdDestino_DPC_id === undefined ) {
                    // this._generalService.toastCall('La Unidad es requerida, error en el renglón ' + index);
                     stringError += 'Error Renglón ' + index + ' El destino es requerido, ';
                     falloGrid = true;
                
                }


                cantidadAguardar++;
            }
        });

        if (falloGrid) {
            this._generalService.toastCall(stringError);
            return false;
        }
        if (cantidadAguardar > 0) {
            if(!falloGrid){
                this.detallePesoCraga = false;
                this.figuraTrasporte = true;
                this.edicionBorrar = false;
                return true;
                
            } 
        } 
   }
    validarMaterial(event: any){
       // console.log(event);
       if(event.value == 0){
        this.materialPeligrosoControl_DPC.reset();
        this.embalajeControl_DPC.reset();
        this.materialPeligrosoControl_DPC.disable();
        this.embalajeControl_DPC.disable();
       }else{
        this.materialPeligrosoControl_DPC.enable();
        this.embalajeControl_DPC.enable();
       }
    }
   
    setearValueDPC(event: any, index: number) {
        
        if (event !== undefined && event !== null) {        
            const producto = this.listaProductos.find((element) => element.ITEM_ID === event.value);
            this.unidadPesoControl.setValue(producto.UNIDAD_PESO_ID);
            this.satIDPesoControl.setValue(producto.ITEM_SAT_ID);
           
            
            this.dimensionesControl_detallePesoCarga.setValue(producto.DIMENSIONS);
            this.pesoBrutoTotalControl.setValue(producto.GROSS_WEIGHT);
            this.pesoNetoTotalControl.setValue(producto.NET_WEIGHT);    
            this.claveMaterialPeligrosoControl_DPC.setValue(producto.HAZARDOUS_MATERIAL);
            this.materialPeligrosoControl_DPC.setValue(producto.HAZARDOUS_MATERIAL_ID);
            this.pesoBruto = producto.GROSS_WEIGHT;
            this.pesoBrutoOriginal = producto.GROSS_WEIGHT;
            this.pesoNeto = producto.NET_WEIGHT;
            this.pesoNetoOriginal = producto.NET_WEIGHT;
            this.embalajeControl_DPC.setValue(producto.BILL_PACKAGING_ID);
            
            if( producto.HAZARDOUS_MATERIAL == 1){
                this.materialPeligrosoControl_DPC.enable();
                this.embalajeControl_DPC.enable();
            }
            this.recalculo = true;
        } 
        else{
            this.unidadPesoControl.reset();
            this.satIDPesoControl.reset();
            
            this.dimensionesControl_detallePesoCarga.reset();
            this.pesoBrutoTotalControl.reset();
            this.pesoNetoTotalControl.reset();
            this.claveMaterialPeligrosoControl_DPC.reset();
            this.materialPeligrosoControl_DPC.reset();
            this.embalajeControl_DPC.reset();
        }
        //Limpiar la Cantidad
        this.cantidadPesoCargaControl.reset();
        this.cantidad ="";
  
    }
    guardarCartaPorteDetalleHeaderPesoCarga() {
        this.edicionBorrar = false;
        this.validarFormularioPesoCarga();
        if (this.formularioValido) {
            this.mapearDatosFormControlEnModeloPesoCarga();
            this.agregarCartaPorteDetallePesoCarga();
        }
    }
    guardarCartaPorteDetalleRowPesoCarga() {
        this.edicionBorrar = false;
        this.validarFormularioPesoCarga();
        if (this.formularioValido) {
            this.mapearDatosFormControlEnModeloPesoCarga();
            this.editarCartaPorteDetallePesoCarga();
        }
    }
    editarCartaPorteDetallePesoCarga() {
       var index: any = 0;  
       this.listaDetalleCartePorte_PesoCarga = this.listaCartaPorteDetallePesoCarga;
        this.listaDetalleCartePorte_PesoCarga.forEach(element => {
            if(element.index == this.cartaPorteDetalle.index){
                index = element.index;
                return;
            }
        });
       
        this.listaCartaPorteAgregar[index] = this.cartaPorteDetalle;
        this.listaDetalleCartePorte_PesoCarga[index] =  this.cartaPorteDetalle;
        
        this.listaCartaPorteDetalle = this.listaCartaPorteDetallePesoCargaFactura.length > 0 ? this.listaCartaPorteDetalle : this.listaDetalleCartePorte_PesoCarga;


        
        this.origenDestinoPesoCarga();
       //this.seEstaAgregando = false;

       this.seEstaEditando = false;
        setTimeout( () => {
          this.dataSource.data = this.listaCartaPorteDetalle;
         
        });
    }
    
    agregarCartaPorteDetallePesoCarga() {
        let index = 0;
        this.listaCartaPorteDetallePesoCargaFactura;
        if(this.editarCartaPorte){
            this.listaDetalleCartePorte_PesoCarga = this.listaCartaPorteDetallePesoCarga;
        }else{
            if( this.listaCartaPorteDetallePesoCargaFactura.length == 0){
                this.listaDetalleCartePorte_PesoCarga = this.listaCartaPorteDetallePesoCarga;
            }else{
                this.listaDetalleCartePorte_PesoCarga = this.listaCartaPorteDetallePesoCargaFactura 
            }
           
        }
        
        if (this.listaDetalleCartePorte_PesoCarga.length === 0) {
                index = 0;
        } else {
                index = this.listaDetalleCartePorte_PesoCarga.length;
        }
        this.cartaPorteDetalle.index = index;
        this.listaDetalleCartePorte_PesoCarga[index] = this.cartaPorteDetalle;
        this.listaCartaPorteDetalle = this.listaDetalleCartePorte_PesoCarga;
       // this.listaCartaPorteDetalle = this.listaCartaPorteDetallePesoCargaFactura.length > 0 ? this.listaCartaPorteDetalle : this.listaDetalleCartePorte_PesoCarga;



        this.origenDestinoPesoCarga();
        this.seEstaEditando = false;
        setTimeout( () => {
          this.dataSource.data = this.listaCartaPorteDetalle;
          this.establecerValoresPorDefectoDetallePeso();
        });
       
    }
    origenDestinoPesoCarga(){
        for (let i = 0; i < this.listaCartaPorteDetalle.length; i++) {
            // Actualizar IdDestino_DPC
            const idDestinoDPC = this.listaCartaPorteDetalle[i]['IdDestino_DPC'];
            const destinoDetalle = this.listDestino.find((e) => e.BILL_CARTA_PORTE_ADDRESS_ID === idDestinoDPC);
            
            if (destinoDetalle !== null && destinoDetalle !== undefined) {
                this.listaCartaPorteDetalle[i]['IdDestino_DPC'] = destinoDetalle.Name_origendestino;
            }
        
            // Actualizar IdOrigen_DPC
            const idOrigenDPC = this.listaCartaPorteDetalle[i]['IdOrigen_DPC'];
            const origenDetalle = this.listOrigen.find((e) => e.BILL_CARTA_PORTE_ADDRESS_ID === idOrigenDPC);
        
            if (origenDetalle !== null && origenDetalle !== undefined) {
                this.listaCartaPorteDetalle[i]['IdOrigen_DPC'] = origenDetalle.Name_origendestino;
            }
        }
    }

    validarFormularioPesoCarga() {
        this.formularioValido = false;
        const campoRequerido = 'Favor de llenar los campos requeridos';
        this.resaltarCamposConErrores();
        if (
            this.pesoBrutoTotalControl.invalid ||
            this.unidadPesoControl.invalid ||
            this.ProductoControl.invalid ||
            this.pesoNetoTotalControl.invalid ||
            this.cantidadPesoCargaControl.invalid ||
            this.cargoTasacionControl.invalid ||
            this.dimensionesControl_detallePesoCarga.invalid ||
            this.materialPeligrosoControl_DPC.invalid ||
            this.claveMaterialPeligrosoControl_DPC.invalid ||
            this.embalajeControl_DPC.invalid  ||
            this.satIDPesoControl.invalid ||
            this.IdOrigenPesoControl.invalid ||
            this.IdDestinonPesoControl.invalid 
            
        ) {
            this.edicionBorrar = true;
            this._generalService.toastCall(campoRequerido);
            return;
        }
        
        this.formularioValido = true;
        // this.btnSigiente=false; 
        this.btnSigienteServicios = false;    
    }
    resaltarCamposConErrores() {
        this.pesoBrutoTotalControl.markAsTouched();
        this.unidadPesoControl.markAsTouched();
        this.ProductoControl.markAsTouched();     
        this.pesoNetoTotalControl.markAsTouched();
        this.descripcionControl.markAsTouched();
        this.cantidadPesoCargaControl.markAsTouched();
        this.cargoTasacionControl.markAsTouched();
        this.dimensionesControl_detallePesoCarga.markAsTouched();
        this.materialPeligrosoControl_DPC.markAsTouched();
        this.claveMaterialPeligrosoControl_DPC.markAsTouched();
        this.embalajeControl_DPC.markAsTouched();
        this.satIDPesoControl.markAsTouched();
        this.IdOrigenPesoControl.markAsTouched();
        this.IdDestinonPesoControl.markAsTouched();
        
    }

    mapearDatosFormControlEnModeloPesoCarga() {
        this.cartaPorteDetalle.ITEM_ID = this.ProductoControl.value;
        const producto = this.listaProductos.find((p) => p.ITEM_ID === this.cartaPorteDetalle.ITEM_ID); 
        if (producto !== null && producto !== undefined){
            this.cartaPorteDetalle.PRODUCTO_DPC = producto.NAME_PRODUCT
            this.cartaPorteDetalle.ITEM_ID = producto.ITEM_ID;
        }
        this.cartaPorteDetalle.UNIDAD_PESO_ID =  this.unidadPesoControl.value
        const unidad = this.listaUnidad.find((p) => p.UNIDAD_PESO_ID === this.cartaPorteDetalle.UNIDAD_PESO_ID); 
        if (unidad !== null && unidad !== undefined){
            this.cartaPorteDetalle.UNIDAD_PESO_DPC = unidad.UNIDAD_PESO;
        }
        this.cartaPorteDetalle.satID = this.satIDPesoControl.value;
        const sat = this.listaSATCode.find((p) => p.itemSATcodeId === this.cartaPorteDetalle.satID ); 
        if (sat !== null && sat !== undefined){
            this.cartaPorteDetalle.satID = sat.sat_name
            this.cartaPorteDetalle.satID_id = sat.itemSATcodeId
        } 


        this.cartaPorteDetalle.cantidad_DPC = this.cantidadPesoCargaControl.value;
        // let cantidad = this.cantidadPesoCargaControl.value;
        // let pesoNeto = this.pesoNetoTotalControl.value;
        // let pesoBruto = this.pesoBrutoTotalControl.value;
        this.cartaPorteDetalle.PESO_BRUTO_TOTAL_DPC = this.pesoBrutoTotalControl.value;
        this.cartaPorteDetalle.PESO_NETO_DPC = this.pesoNetoTotalControl.value;
       



        this.cartaPorteDetalle.Cargo_Tasacion_DPC = this.cargoTasacionControl.value; 



        this.cartaPorteDetalle.DIMENSIONES_DPC = this.dimensionesControl_detallePesoCarga.value;  
        this.cartaPorteDetalle.CLAVEMATERIALPELIGROSO_DPC = this.claveMaterialPeligrosoControl_DPC.value;
        this.cartaPorteDetalle.IdOrigen_DPC_id = this.IdOrigenPesoControl.value;
        const origen = this.listOrigen.find((e) => e.BILL_CARTA_PORTE_ADDRESS_ID === this.cartaPorteDetalle.IdOrigen_DPC_id);
        if (origen !== null && origen !== undefined){
            this.cartaPorteDetalle.IdOrigen_DPC = origen.Name_origendestino;
        } 
        this.cartaPorteDetalle.IdDestino_DPC_id = this.IdDestinonPesoControl.value;
        const destino = this.listDestino.find((e) => e.BILL_CARTA_PORTE_ADDRESS_ID === this.cartaPorteDetalle.IdDestino_DPC_id);
        if (destino !== null && destino !== undefined){
            this.cartaPorteDetalle.IdDestino_DPC = destino.Name_origendestino;  
        }
        this.cartaPorteDetalle.EMBALAJE_DPC = this.embalajeControl_DPC.value;
        const embalaje = this.listaembalaje.find((e) => e.BILL_PACKAGING_ID === this.cartaPorteDetalle.EMBALAJE_DPC);
        if (embalaje !== null && embalaje !== undefined){
            this.cartaPorteDetalle.EMBALAJE_DPC = embalaje.BILL_PACKAGING_VALUE;
            this.cartaPorteDetalle.EMBALAJE_DPC_id = embalaje.BILL_PACKAGING_ID;
        } 
        this.cartaPorteDetalle.MATERIALPELIGROSO_DPC = this.materialPeligrosoControl_DPC.value;
        const material = this.listamaterialesPeligrosos.find((m) => m.HAZARDOUS_MATERIAL_ID === this.cartaPorteDetalle.MATERIALPELIGROSO_DPC);
        if (material !== null && material !== undefined){
            this.cartaPorteDetalle.MATERIALPELIGROSO_DPC = material.HAZARDOUS_MATERIAL_NAME;
            this.cartaPorteDetalle.MATERIALPELIGROSO_DPC_id = material.HAZARDOUS_MATERIAL_ID;
        } 
        const i = this.materialPeligrosoOption.find((m) => m.CLAVEMATERIALPELIGROSO_DPC === this.cartaPorteDetalle.CLAVEMATERIALPELIGROSO_DPC);
        if (i !== null && i !== undefined){
            this.cartaPorteDetalle.CLAVEMATERIALPELIGROSO_DPC = i.value;
            this.cartaPorteDetalle.CLAVEMATERIALPELIGROSO_DPC_id = i.CLAVEMATERIALPELIGROSO_DPC;
        }    
    }

    establecerDetallePesoCarga(cartaPorteDetalle: CartaPorteDetalle) {
        this.cartaPorteDetalle = new CartaPorteDetalle();
        // this.seEstaAgregando = false;
        this.seEstaEditando = true;
        this.cartaPorteDetalle = cartaPorteDetalle;
        this.cartaPorteDetalle.DETAIL_ID = cartaPorteDetalle.DETAIL_ID;
        this.transaccionEnCurso = true;
        this.ProductoControl.setValue(cartaPorteDetalle.ITEM_ID);
        this.unidadPesoControl.setValue(cartaPorteDetalle.UNIDAD_PESO_DPC);
        this.pesoNetoTotalControl.setValue(cartaPorteDetalle.PESO_NETO_DPC);
        this.cantidadPesoCargaControl.setValue(cartaPorteDetalle.cantidad_DPC);
        this.cargoTasacionControl.setValue(cartaPorteDetalle.Cargo_Tasacion_DPC);
        this.pesoBrutoTotalControl.setValue(cartaPorteDetalle.PESO_BRUTO_TOTAL_DPC);
        
        this.dimensionesControl_detallePesoCarga.setValue(cartaPorteDetalle.DIMENSIONES_DPC);
        this.materialPeligrosoControl_DPC.setValue(cartaPorteDetalle.MATERIALPELIGROSO_DPC);
        
        cartaPorteDetalle.CLAVEMATERIALPELIGROSO_DPC_id == undefined ? this.claveMaterialPeligrosoControl_DPC.setValue(cartaPorteDetalle.CLAVEMATERIALPELIGROSO_DPC_aux) : this.claveMaterialPeligrosoControl_DPC.setValue(cartaPorteDetalle.CLAVEMATERIALPELIGROSO_DPC_id);
        
        this.embalajeControl_DPC.setValue(cartaPorteDetalle.EMBALAJE_DPC);
        this.satIDPesoControl.setValue(cartaPorteDetalle.satID);

        if( cartaPorteDetalle.CLAVEMATERIALPELIGROSO_DPC_aux == 1){
            this.materialPeligrosoControl_DPC.enable();
            this.embalajeControl_DPC.enable();
        }

        this.transaccionEnCurso = false;
        //this.camposOrigenDestino(this.dataSource);

        this.IdOrigenPesoControl.setValue(cartaPorteDetalle.IdOrigen_DPC);
        this.IdDestinonPesoControl.setValue(cartaPorteDetalle.IdDestino_DPC);
    }
    
    eliminarRow(element) {
        //this.listaCartaPorteDetalle = this.listaDetalleCartePorte_PesoCarga;
        this.listaCartaPorteDetalle;
        const index = this.listaCartaPorteDetalle.findIndex((obj) => obj.index === element.index);
       
        if (element.BILL_CARTA_PORTE_WEIGHT_DETAIL_ID !== null && element.BILL_CARTA_PORTE_WEIGHT_DETAIL_ID !== undefined) {
            
            this.eliminarDetallePesoCarga(this.listaCartaPorteDetalle[index]);
        } else {
            this.eliminar(element.index);
        }

        if (this.dataSource.data.length == 0) {
            this.btnSigienteServicios = true;
        }else{
            this.btnSigienteServicios = false;
        }
    }
    eliminarDetallePesoCarga(cartaPorteDetalle: CartaPorteDetalle){
        const metodo = 'factura/deleteDetalleCartaPorte';
        this._generalService.metodoCallParams(cartaPorteDetalle, metodo).subscribe(
            (result) => {

                this._generalService.toastCall('Se ha eliminado el renglon exitosamente!');
                this.getCartaPorteDetalle(this.dataSource);
               // this.camposOrigenDestino(this.dataSource);
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );

    }
    eliminar(id) {
        const index = this.listaCartaPorteDetalle.findIndex((element) => element.index === id);
        this.listaCartaPorteDetalle.splice(index, 1);
        this.listaCartaPorteAgregar.splice(index, 1);
        if(this.listaCartaPorteDetallePesoCargaFactura.length > 0 && !this.editarCartaPorte){
            this.listaCartaPorteDetalle.splice(index, 1);
            this.listaCartaPorteDetallePesoCargaFactura.splice(index, 1);
        }
        
        setTimeout( () => {
            this.dataSource.data = this.listaCartaPorteDetalle;
        });
    }
    establecerValoresPorDefectoDetallePeso() {
        this.cartaPorteDetalle = new CartaPorteDetalle();
        this.seEstaEditando = false;
        this.seEstaAgregandoDetallePeso = false;
        this.pesoBrutoTotalControl.reset();
        this.unidadPesoControl.reset();
        this.ProductoControl.reset();
        this.pesoNetoTotalControl.reset();
        this.cantidadPesoCargaControl.reset();
        this.cargoTasacionControl.reset();
        this.dimensionesControl_detallePesoCarga.reset();
        this.materialPeligrosoControl_DPC.reset();
        this.claveMaterialPeligrosoControl_DPC.reset();
        this.embalajeControl_DPC.reset();
        this.satIDPesoControl.reset();
        this.IdOrigenPesoControl.reset();
        this.IdDestinonPesoControl.reset();
    }

    //-------------------------------------------------------------Servcios--------------------------------
    // setearValueSRV(event: any, index: number) {
    //     if (event !== undefined && event !== null) {        
    //         const producto = this.listaProductosServicios.find((element) => element.ITEM_ID === event.value);
    //         this.unidadControl.setValue(producto.UNIDAD_PESO_ID);
    //         this.descripcionControl.setValue(producto.NAME_PRODUCT);
    //     } 
    //     else{
    //         this.unidadControl.reset();
    //         this.descripcionControl.reset();
    //     }
    // }
    // guardarCartaPorteDetalleHeaderServicios() {
    //     this.edicionBorrar = false;
    //     this.validarFormularioServicos();
    //     if (this.formularioValido) {
    //         this.mapearDatosFormControlEnModeloServcios();
    //         this.agregarCartaPorteDetalleServicios();
    //     }
    // }
    // guardarCartaPorteDetalleRowServicio() {
    //     this.validarFormularioServicos();
    //     if (this.formularioValido) {
    //         this.mapearDatosFormControlEnModeloServcios();
    //         this.editarCartaPorteDetalleServicio();
    //     }
    // }
    // editarCartaPorteDetalleServicio() {
    //     var index: any = 0;  
    //    this.listaDetalleCartePorte_Servicios = this.listaCartaPorteDetalleServicos;
    //     this.listaDetalleCartePorte_Servicios.forEach(element => {
    //         if(element.index == this.cartaPorteDetalle.index){
    //             index = element.index;
    //             return;
    //         }
    //     });

    //     this.cartaPorteDetalle.index = index;
    //     this.listaDetalleCartePorte_Servicios[index] = this.cartaPorteDetalle;
    
    //     this.listaCartaPorteDetalle = this.listaDetalleCartePorte_Servicios;

    //     this.seEstaEditando1 = false;
    //     setTimeout( () => {
    //       this.dataSource01.data = this.listaCartaPorteDetalle;
         
    //     });
    // }
    // validarFormularioServicos() {
    //     this.formularioValido = false;
    //     const campoRequerido = 'Favor de llenar los campos requeridos';
    //     this.resaltarCamposConErroresServicios();
    //     if (
    //         this.bienesTrasportadosControl.invalid ||
    //         this.claveSTCCControl.invalid ||
    //         this.descripcionControl.invalid ||
    //         this.cantidadControl.invalid ||
    //         this.claveUnidadControl.invalid ||
    //         this.unidadControl.invalid ||
    //         this.ProductoControlServicios.invalid ||
    //         this.dimensionesControl.invalid ||
    //         this.materialPeligrosoControl.invalid ||
    //         this.claveMaterialPeligrosoControl.invalid ||
    //         this.embalajeControl.invalid ||
    //         this.descripcionEmbalajeControl.invalid ||
    //         this.pesoKGControl.invalid ||
    //         this.valorMercanciaControl.invalid ||
    //         this.monedaControl.invalid ||
    //         this.fraccionArancelariaControl.invalid ||
    //         this.UUIDControl.invalid ||
    //         this.importeControl.invalid
           
    //     ) {
    //         this.edicionBorrar = true;
    //         this._generalService.toastCall(campoRequerido);
    //         return;
    //     }
    //     this.formularioValido = true;
    //     this.btnSigiente=false;  
    // }
    // resaltarCamposConErroresServicios() {
    //     this.bienesTrasportadosControl.markAsTouched();
    //     this.claveSTCCControl.markAsTouched();
    //     this.descripcionControl.markAsTouched();
    //     this.cantidadControl.markAsTouched();
    //     this.claveUnidadControl.markAsTouched();
    //     this.unidadControl.markAsTouched();
    //     this.ProductoControlServicios.markAsTouched();
    //     this.dimensionesControl.markAsTouched();
    //     this.materialPeligrosoControl.markAsTouched();
    //     this.claveMaterialPeligrosoControl.markAsTouched();
    //     this.embalajeControl.markAsTouched();
    //     this.descripcionEmbalajeControl.markAsTouched();
    //     this.pesoKGControl.markAsTouched();
    //     this.valorMercanciaControl.markAsTouched();
    //     this.monedaControl.markAsTouched();
    //     this.fraccionArancelariaControl.markAsTouched();
    //     this.UUIDControl.markAsTouched();
    //     this.importeControl.markAsUntouched();
    // }
    // mapearDatosFormControlEnModeloServcios() {
    //     this.cartaPorteDetalle.ITEM_ID = this.ProductoControlServicios.value;
    //      const producto = this.listaProductosServicios.find((p) => p.ITEM_ID === this.cartaPorteDetalle.ITEM_ID); 
    //      if (producto !== null && producto !== undefined){
    //         this.cartaPorteDetalle.PRODUCTO_SR = producto.NAME_PRODUCT
    //         this.cartaPorteDetalle.ITEM_ID = producto.ITEM_ID;
    //     } 

    //     this.cartaPorteDetalle.UNIDAD_PESO_ID =  this.unidadControl.value
    //     const unidad = this.listaUnidad.find((p) => p.UNIDAD_PESO_ID === this.cartaPorteDetalle.UNIDAD_PESO_ID); 
    //     if (unidad !== null && unidad !== undefined){
    //         this.cartaPorteDetalle.UNIDAD_SR = unidad.UNIDAD_PESO;
    //     }

    //     this.cartaPorteDetalle.MATERIALPELIGROSO_SR = this.materialPeligrosoControl.value;
    //     const material = this.listamaterialesPeligrosos.find((m) => m.HAZARDOUS_MATERIAL_ID === this.cartaPorteDetalle.MATERIALPELIGROSO_SR);
    //     if (material !== null && material !== undefined){
    //         this.cartaPorteDetalle.MATERIALPELIGROSO_SR = material.HAZARDOUS_MATERIAL_NAME;
    //         this.cartaPorteDetalle.MATERIALPELIGROSO_ID_SR = material.HAZARDOUS_MATERIAL_ID;
    //     } 
    //     this.cartaPorteDetalle.BIENES_TRASPORTADOS_SR = this.bienesTrasportadosControl.value;
    //     this.cartaPorteDetalle.UNIDAD_PESO_ID_SR = this.unidadControl.value;
    //     this.cartaPorteDetalle.CLAVE_STC_SR = this.claveSTCCControl.value;
    //     this.cartaPorteDetalle.DESCRIPCION_SR = this.descripcionControl.value;
    //     this.cartaPorteDetalle.CANTIDAD_SR = this.cantidadControl.value;
    //     this.cartaPorteDetalle.CLAVEUNIDAD_SR = this.claveUnidadControl.value;
       
    //     this.cartaPorteDetalle.DIMENSIONES_SR = this.dimensionesControl.value;
        
    //     this.cartaPorteDetalle.CLAVEMATERIALPELIGROSO_SR = this.claveMaterialPeligrosoControl.value;
    //     this.cartaPorteDetalle.EMBALAJE_SR = this.embalajeControl.value;
    //     const embalaje = this.listaembalaje.find((e) => e.BILL_PACKAGING_ID === this.cartaPorteDetalle.EMBALAJE_SR);
    //     if (embalaje !== null && embalaje !== undefined){
    //         this.cartaPorteDetalle.EMBALAJE_SR = embalaje.BILL_PACKAGING_VALUE;
    //         this.cartaPorteDetalle.EMBALAJE_ID_SR = embalaje.BILL_PACKAGING_ID;
    //     } 
    //     this.cartaPorteDetalle.DESCRIPCIONEMBALAJE_SR = this.descripcionEmbalajeControl.value;
    //     this.cartaPorteDetalle.PESO_KG_SR = this.pesoKGControl.value;
    //     this.cartaPorteDetalle.VALOR_MERCANCIA_SR = this.valorMercanciaControl.value;
    //     this.cartaPorteDetalle.MONEDA_SR = this.monedaControl.value;
    //     const moneda = this.listaMoneda.find((i) => i.CURRENCY_ID === this.cartaPorteDetalle.MONEDA_SR);
    //     if (moneda !== null && moneda !== undefined){
    //         this.cartaPorteDetalle.MONEDA_SR = moneda.CURRENCY_VALUE;
    //         this.cartaPorteDetalle.MONEDA_ID_SR = moneda.CURRENCY_ID;
    //     }
    //     this.cartaPorteDetalle.FRACCION_ARANCELARIA_SR = this.fraccionArancelariaControl.value;
    //     this.cartaPorteDetalle.UUID_SR = this.UUIDControl.value;
    //     let valorUnitario = this.valorMercanciaControl.value;
    //     let cantidad = this.cantidadControl.value;
    //     this.cartaPorteDetalle.AMOUNT = (valorUnitario * cantidad);
        
    // }
    // agregarCartaPorteDetalleServicios() {
    //     let index = 0;
    //     this.listaDetalleCartePorte_Servicios = this.listaCartaPorteDetalleServicos;
    //     if (this.listaDetalleCartePorte_Servicios.length === 0) {
    //          index = 0;
    //     } else {
    //          index = this.listaDetalleCartePorte_Servicios.length;
    //     }
    //     this.cartaPorteDetalle.index = index;
    //     this.listaDetalleCartePorte_Servicios[index] = this.cartaPorteDetalle;
    //     this.listaCartaPorteDetalle = this.listaDetalleCartePorte_Servicios;
    //     this.listaCartaPorteDetalle_SR = this.listaDetalleCartePorte_Servicios



    //     //this.seEstaAgregando = false;
    //     this.seEstaEditando = false;
    //     setTimeout( () => {
    //       this.dataSource01.data = this.listaCartaPorteDetalle_SR;
    //       this.establecerValoresDefectosDetalleServicios();
    //     });
    // }
    // establecerDetalleServicos(cartaPorteDetalle: CartaPorteDetalle){
    //     this.cartaPorteDetalle = new CartaPorteDetalle();
    //     this.seEstaEditando1 = true;
    //     this.cartaPorteDetalle = cartaPorteDetalle;
       
    //     this.transaccionEnCurso = true;
      
    //     this.bienesTrasportadosControl.setValue(cartaPorteDetalle.BIENES_TRASPORTADOS_SR);
    //     this.ProductoControlServicios.setValue(cartaPorteDetalle.ITEM_ID);
    //     this.claveSTCCControl.setValue(cartaPorteDetalle.CLAVE_STC_SR);
    //     this.descripcionControl.setValue(cartaPorteDetalle.DESCRIPCION_SR);
    //     this.cantidadControl.setValue(cartaPorteDetalle.CANTIDAD_SR);
    //     this.claveUnidadControl.setValue(cartaPorteDetalle.CLAVEUNIDAD_SR);
        
    //     this.unidadControl.setValue(cartaPorteDetalle.UNIDAD_SR);
       
    //     this.dimensionesControl.setValue(cartaPorteDetalle.DIMENSIONES_SR);
    //     this.materialPeligrosoControl.setValue(cartaPorteDetalle.MATERIALPELIGROSO_SR);
    //     this.claveMaterialPeligrosoControl.setValue(cartaPorteDetalle.CLAVEMATERIALPELIGROSO_SR);
    //     this.embalajeControl.setValue(cartaPorteDetalle.EMBALAJE_SR);
    //     this.descripcionEmbalajeControl.setValue(cartaPorteDetalle.DESCRIPCIONEMBALAJE_SR);
    //     this.pesoKGControl.setValue(cartaPorteDetalle.PESO_KG_SR);
    //     this.valorMercanciaControl.setValue(cartaPorteDetalle.VALOR_MERCANCIA_SR);
    //     this.monedaControl.setValue(cartaPorteDetalle.MONEDA_SR);
    //     this.fraccionArancelariaControl.setValue(cartaPorteDetalle.FRACCION_ARANCELARIA_SR);
    //     this.UUIDControl.setValue(cartaPorteDetalle.UUID_SR);
    //     this.importeControl.setValue(cartaPorteDetalle.AMOUNT);
        

    //     this.transaccionEnCurso = false;
    // }
    // eliminarRowServicios(element1) {
    //     this.listaCartaPorteDetalle_SR
    //     const index = this.listaCartaPorteDetalle_SR.findIndex((obj) => obj.index === element1.index);

    //     if (element1.BILL_CARTA_PORTE_SERVICES_DETAIL_ID !== null && element1.BILL_CARTA_PORTE_SERVICES_DETAIL_ID !== undefined) {
            
    //         this.eliminarDetalleServicio(this.listaCartaPorteDetalle_SR[index]);
    //     } else {
    //         this.eliminarServicos(element1.index);
    //     }
        
    //     if (this.dataSource01.data.length == 0) {
    //         this.btnSigiente = true;
    //     }
    // }
    // eliminarDetalleServicio(cartaPorteDetalle: CartaPorteDetalle){
    //     const metodo = 'factura/deleteDetalleCartaPorte';
    //     this._generalService.metodoCallParams(cartaPorteDetalle, metodo).subscribe(
    //         (result) => {
    //             this._generalService.toastCall('Se ha eliminado el renglon exitosamente!');
               
    //             this.getCartaPorteDetalle(this.dataSource01);
    //         },
    //         (error) => {
    //         const errorMsj =  error as any;
    //         console.log(errorMsj);
    //         }
    //     );
    // }
    // eliminarServicos(id) {
    //     const index = this.listaDetalleCartePorte_Servicios.findIndex((element1) => element1.index === id);
    //     this.listaDetalleCartePorte_Servicios.splice(index, 1);
    //     this.listaCartaPorteAgregar.splice(index, 1);
    //     this.listaCartaPorteDetalle_SR = this.listaDetalleCartePorte_Servicios
       
    //     setTimeout( () => {
    //         this.dataSource01.data = this.listaCartaPorteDetalle_SR;
    //     });
    // }
    // establecerValoresDefectosDetalleServicios(){
    //     this.cartaPorteDetalle = new CartaPorteDetalle();
    //     this.seEstaEditando1 = false;
    //     this.seEstaAgregandoDetalleServicios = false;
    //     this.bienesTrasportadosControl.reset();
    //     this.claveSTCCControl.reset();
    //     this.descripcionControl.reset();
    //     this.cantidadControl.reset();
    //     this.claveUnidadControl.reset();
    //     this.unidadControl.reset();
    //     this.ProductoControlServicios.reset();
    //     this.dimensionesControl.reset();
    //     this.materialPeligrosoControl.reset();
    //     this.claveMaterialPeligrosoControl.reset();
    //     this.embalajeControl.reset();
    //     this.descripcionEmbalajeControl.reset();
    //     this.pesoKGControl.reset();
    //     this.valorMercanciaControl.reset();
    //     this.monedaControl.reset();
    //     this.fraccionArancelariaControl.reset();
    //     this.UUIDControl.reset();
    //     this.importeControl.reset();
    // }

    //-------------------------------------------------------------Ubicaciones--------------------------------
    

    guardarCartaPorteDetalleHeaderUbicaciones(){
        this.edicionBorrar = false;
        this.validarFormularioUbicaciones();
        if (this.formularioValido) {
            this.mapearDatosFormControlEnModeloUbicaciones();
            this.agregarCartaPorteDetalleUbicacion();
        }
    }
    validarFormularioUbicaciones() {
        this.formularioValido = false;
        const campoRequerido = 'Favor de llenar los campos requeridos';
        this.resaltarCamposConErroresUbicaciones();
        if (
            this.UbicacionesControl.invalid ||
            this.tipoubicacionControl.invalid ||
            this.RFCUbicacionControl.invalid ||
            this.fechaHoraControl.invalid ||
            this.salidaLlegadaControl.invalid ||
            this.distanciaRecorridaControl.invalid ||
            this.paisUbicacionControl.invalid ||
            this.C_LOCALIDADControl.invalid ||
            this.C_LOCALIDAD_ValueControl.invalid ||
            this.CPUbicacionControl.invalid ||
            this.estadoUbicacionControl.invalid ||
            this.municipioUbicacionControl.invalid ||
            this.coloniaUbicacionControl.invalid ||
            this.calleUbicacionControl.invalid ||
            this.numExterioUbicacionControl.invalid ||
            this.numInteriorUbicacionControl.invalid ||
            this.referenciaUbicacionControl.invalid 
              
        ) {
            this.edicionBorrar = true;
            this._generalService.toastCall(campoRequerido);
            return;
        }
        this.formularioValido = true;   
    }
    resaltarCamposConErroresUbicaciones() {
        this.UbicacionesControl.markAsTouched();
        this.tipoubicacionControl.markAsTouched();
        this.RFCUbicacionControl.markAsTouched();
        this.fechaHoraControl.markAsTouched();
        this.salidaLlegadaControl.markAsTouched();
        this.distanciaRecorridaControl.markAsTouched();
        this.paisUbicacionControl.markAsTouched();
        this.C_LOCALIDADControl.markAsTouched();
       this. C_LOCALIDAD_ValueControl.markAsTouched();
        this.CPUbicacionControl.markAsTouched();
        this.estadoUbicacionControl.markAsTouched();
        this.municipioUbicacionControl.markAsTouched();
        this.coloniaUbicacionControl.markAsTouched();
        this.calleUbicacionControl.markAsTouched();
        this.numExterioUbicacionControl.markAsTouched();
        this.numInteriorUbicacionControl.markAsTouched();
        this.referenciaUbicacionControl.markAsTouched();
    }
    mapearDatosFormControlEnModeloUbicaciones() {
        this.cartaPorteDetalle.UBICACIONES_UBICACION_number = this.UbicacionesControl.value;
        this.cartaPorteDetalle.TIPO_UBICACION_opcion = this.tipoubicacionControl.value;

        const tipo_Ubicacion_s = this.tiposUbicaciones.find((tp) => tp.BILL_CARTA_PORTE_TYPE === this.tipoubicacionControl.value);
      
        if (tipo_Ubicacion_s !== null && tipo_Ubicacion_s !== undefined){
            this.cartaPorteDetalle.BILL_CARTA_PORTE_TYPE = tipo_Ubicacion_s.value;
        } 
        const Ubicacion_s = this.selectUbicaciones.find((u) => u.id_Ubicaciones === this.UbicacionesControl.value);
        if (Ubicacion_s !== null && Ubicacion_s !== undefined){
            
            this.cartaPorteDetalle.UBICACIONES_UBICACION = Ubicacion_s.value;
        } 
 
        this.cartaPorteDetalle.RFC_UBICACION = this.RFCUbicacionControl.value;
        this.cartaPorteDetalle.FECHAHORA_UBICACION = this.fechaHoraControl.value;
        this.cartaPorteDetalle.SALIDALLEGADA_UBICACION = this.salidaLlegadaControl.value;
        this.cartaPorteDetalle.DISTANCIA_RECORRIDA_UBICACION = this.distanciaRecorridaControl.value;
        this.cartaPorteDetalle.PAIS_UBICACION = this.paisUbicacionControl.value;
        this.cartaPorteDetalle.C_LOCALIDAD = this.C_LOCALIDADControl.value;
         this.cartaPorteDetalle.C_LOCALIDAD_Value = this.C_LOCALIDAD_ValueControl.value;
        this.cartaPorteDetalle.CP_UBICACION = this.CPUbicacionControl.value;
        this.cartaPorteDetalle.ESTADO_UBICACION = this.estadoUbicacionControl.value;
        this.cartaPorteDetalle.MUNICIPIO_UBICACION = this.municipioUbicacionControl.value;
        this.cartaPorteDetalle.CITY_ID_Ubicaciones = this.CYTI_ID_contol.value;
        this.cartaPorteDetalle.COLONIA_UBICACION = this.coloniaUbicacionControl.value;
        this.cartaPorteDetalle.CALLE_UBICACION = this.calleUbicacionControl.value;
        this.cartaPorteDetalle.NUM_EXTERIO_UBICACION = this.numExterioUbicacionControl.value;
        this.cartaPorteDetalle.NUM_INTERIOR_UBICACION = this.numInteriorUbicacionControl.value;
        this.cartaPorteDetalle.REFERENCIA_UBICACION = this.referenciaUbicacionControl.value;   
        this.ID_origendestino  = this.IDorigendestino.value;
    }
    agregarCartaPorteDetalleUbicacion() {
        let index = 0;

        this.listaDetalleCartePorte_Ubicacion = this.listaCartaPorteDetalleUbicaciones;
        if (this.listaDetalleCartePorte_Ubicacion.length === 0) {
             index = 0;
        } else {
            index = this.listaDetalleCartePorte_Ubicacion.length;
        }
        this.cartaPorteDetalle.ID_origendestino =  this.ID_origendestino;
        this.cartaPorteDetalle.index = index;
        this.listaDetalleCartePorte_Ubicacion[index] = this.cartaPorteDetalle;

        this.listaCartaPorteDetalle_U
        
         //-------------------Validaciones Origen Destino

        let contadorO = 0;
        let contadorD = 0;

         for (let i = 0; i < this.listaDetalleCartePorte_Ubicacion.length; i++) {
            if (this.listaDetalleCartePorte_Ubicacion[i]['TIPO_UBICACION_opcion'] === "O") {
                contadorO++;
                this.listaDetalleCartePorte_Ubicacion[i]['ID_origendestino'] = 'OR'  + contadorO.toString().padStart(6, '0');
                
            }
            if (this.listaDetalleCartePorte_Ubicacion[i]['TIPO_UBICACION_opcion'] === "D") {
                contadorD++;
                this.listaDetalleCartePorte_Ubicacion[i]['ID_origendestino'] = 'DE' + contadorD.toString().padStart(6, '0');
            }
        }
         if(contadorO >= 1 && contadorD>= 1){
             this.btnValidarUbucaciones = false;
         }
         //-----------------------------------------------

        this.seEstaEditando2 = false;
        setTimeout( () => {
          this.dataSource02.data = this.listaDetalleCartePorte_Ubicacion;
          this.establecerValoresDefectosUbicaciones();
        });
    }
    eliminarRowUbicaciones(element2) {
        const index = this.listaCartaPorteDetalle_U.findIndex((obj) => obj.index === element2.index);
        
        if(element2.BILL_CARTA_PORTE_ADDRESS_ID !== null && element2.BILL_CARTA_PORTE_ADDRESS_ID !== undefined){
            this.eliminarDetalleUbiaciones(this.listaCartaPorteDetalle_U[index]);
            //console.log('eliminar de db')
        }else{
            this.eliminarUbicaciones(element2.index);
        }

        this.getCartaPorteDetalle(this.dataSource02);

        let contadorO = 0;
        let contadorD = 0;

         for (let i = 0; i < this.listaDetalleCartePorte_Ubicacion.length; i++) {
            if (this.listaDetalleCartePorte_Ubicacion[i]['TIPO_UBICACION_opcion'] === "O") {
                contadorO++;
                this.listaDetalleCartePorte_Ubicacion[i]['ID_origendestino'] = 'OR'  + contadorO.toString().padStart(6, '0');
                
            }
            if (this.listaDetalleCartePorte_Ubicacion[i]['TIPO_UBICACION_opcion'] === "D") {
                contadorD++;
                this.listaDetalleCartePorte_Ubicacion[i]['ID_origendestino'] = 'DE' + contadorD.toString().padStart(6, '0');
            }
        }
        if(contadorO >= 1 && contadorD>= 1){
            this.btnValidarUbucaciones = false;
        }else{
            this.btnValidarUbucaciones = true;
        }  
    }
    eliminarDetalleUbiaciones(cartaPorteDetalle: CartaPorteDetalle){
        this.btnDeleteUbicaiones = true;
        const metodo = 'factura/deleteDetalleCartaPorte';
        this._generalService.metodoCallParams(cartaPorteDetalle, metodo).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                this.listaubicacionesEliminadas = tableResult.Table;
                this.listaubicacionesEliminadas[0]['Message'] === '1' ? this._generalService.toastCall('El registro no se puede eliminar ya que tiene productos vinculados!') 
                                                            :this._generalService.toastCall('Se ha eliminado el renglon exitosamente!');

                this.getCartaPorteDetalle(this.dataSource02);  
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );
    }

    eliminarUbicaciones(id) {
        const index = this.listaDetalleCartePorte_Ubicacion.findIndex((element2) => element2.index === id);
        this.listaDetalleCartePorte_Ubicacion.splice(index, 1);
        this.listaCartaPorteAgregar.splice(index, 1);
        this.listaDetalleCartePorte_Ubicacion;
        setTimeout( () => {
            this.dataSource02.data = this.listaDetalleCartePorte_Ubicacion;
        });
    }
    establecerDetalleUbicaciones(cartaPorteDetalle: CartaPorteDetalle){
        this.cartaPorteDetalle = new CartaPorteDetalle();
        this.seEstaEditando2 = true;
        this.cartaPorteDetalle = cartaPorteDetalle;
        this.transaccionEnCurso = true;
        this.tipoubicacionControl.setValue(cartaPorteDetalle.TIPO_UBICACION_opcion);
        this.selctionTipoUbicacion(cartaPorteDetalle.TIPO_UBICACION_opcion, 0);
        if(cartaPorteDetalle.UBICACIONES_UBICACION_number == null){
            this.UbicacionesControl.setValue(0);
        }else{
            this.UbicacionesControl.setValue(cartaPorteDetalle.UBICACIONES_UBICACION_number);
        }

        this.RFCUbicacionControl.setValue(cartaPorteDetalle.RFC_UBICACION);
        this.fechaHoraControl.setValue(cartaPorteDetalle.FECHAHORA_UBICACION);        
        this.salidaLlegadaControl.setValue(cartaPorteDetalle.SALIDALLEGADA_UBICACION);
        this.distanciaRecorridaControl.setValue(cartaPorteDetalle.DISTANCIA_RECORRIDA_UBICACION);
        this.paisUbicacionControl.setValue(cartaPorteDetalle.PAIS_UBICACION);
        this.C_LOCALIDADControl.setValue(cartaPorteDetalle.C_LOCALIDAD);
         this.C_LOCALIDAD_ValueControl.setValue(cartaPorteDetalle.C_LOCALIDAD_Value);
        this.CPUbicacionControl.setValue(cartaPorteDetalle.CP_UBICACION);
        this.estadoUbicacionControl.setValue(cartaPorteDetalle.ESTADO_UBICACION);
        this.municipioUbicacionControl.setValue(cartaPorteDetalle.MUNICIPIO_UBICACION);
        this.CYTI_ID_contol.setValue(cartaPorteDetalle.CITY_ID_Ubicaciones)
        this.coloniaUbicacionControl.setValue(cartaPorteDetalle.COLONIA_UBICACION);
        this.calleUbicacionControl.setValue(cartaPorteDetalle.CALLE_UBICACION);
        this.numExterioUbicacionControl.setValue(cartaPorteDetalle.NUM_EXTERIO_UBICACION);
        this.numInteriorUbicacionControl.setValue(cartaPorteDetalle.NUM_INTERIOR_UBICACION);
        this.referenciaUbicacionControl.setValue(cartaPorteDetalle.REFERENCIA_UBICACION);
        this.IDorigendestino.setValue(cartaPorteDetalle.ID_origendestino);
        this.transaccionEnCurso = false;
    }
    guardarCartaPorteDetalleRowUbicacion(){
        this.validarFormularioUbicaciones();
        if (this.formularioValido) {
            this.mapearDatosFormControlEnModeloUbicaciones();
            this.editarCartaPorteDetalleUbicaciones();
        }
    }
    editarCartaPorteDetalleUbicaciones() {

        var index: any = 0;  
       this.listaDetalleCartePorte_Ubicacion = this.listaCartaPorteDetalleUbicaciones;
        this.listaDetalleCartePorte_Ubicacion.forEach(element => {
            if(element.index == this.cartaPorteDetalle.index){
                index = element.index;
                return;
            }
        });
        this.cartaPorteDetalle.ID_origendestino =  this.ID_origendestino;
        this.cartaPorteDetalle.index = index;
        this.listaDetalleCartePorte_Ubicacion[index] = this.cartaPorteDetalle;
        this.listaCartaPorteDetalle = this.listaDetalleCartePorte_Ubicacion;
      
        this.listaDetalleCartePorte_Ubicacion;
        let contadorO = 0;
         let contadorD = 0;

         for (let i = 0; i < this.listaCartaPorteDetalle.length; i++) {
            if (this.listaCartaPorteDetalle[i]['TIPO_UBICACION_opcion'] === "O") {
                contadorO++;
                this.listaCartaPorteDetalle[i]['ID_origendestino'] = 'OR'  + contadorO.toString().padStart(6, '0');
                
            }
            if (this.listaCartaPorteDetalle[i]['TIPO_UBICACION_opcion'] === "D") {
                contadorD++;
                this.listaCartaPorteDetalle[i]['ID_origendestino'] = 'DE' + contadorD.toString().padStart(6, '0');
            }
        }
         if(contadorO >= 1 && contadorD>= 1){
             this.btnValidarUbucaciones = false;
         }
       
        this.listaDetalleCartePorte_Ubicacion = this.listaCartaPorteDetalle
        this.seEstaEditando2 = false;
        setTimeout( () => {
          this.dataSource02.data = this.listaCartaPorteDetalle;
        });
    }

    establecerValoresDefectosUbicaciones(){
        this.seEstaEditando2 = false;
        this.seEstaAgregandoUbicaciones = false;
        this.UbicacionesControl.reset();
        this.tipoubicacionControl.reset();
        this.RFCUbicacionControl.reset();
        this.distanciaRecorridaControl.reset();
        this.fechaHoraControl.reset();
        this.salidaLlegadaControl.reset();
        this.paisUbicacionControl.reset();
        this.C_LOCALIDADControl.reset();
        this.C_LOCALIDAD_ValueControl.reset();
        
        this.CPUbicacionControl.reset();
        this.estadoUbicacionControl.reset();
        this.municipioUbicacionControl.reset();
        this.CYTI_ID_contol.reset();
        this.coloniaUbicacionControl.reset();
        this.calleUbicacionControl.reset();
        this.numExterioUbicacionControl.reset();
        this.numInteriorUbicacionControl.reset();
        this.referenciaUbicacionControl.reset();
        this.commentsUbicacionesControl.reset();
    }
    resetUbicacionesALL(){
        this.UbicacionesControl.reset();
        this.RFCUbicacionControl.reset();
        this.distanciaRecorridaControl.reset();
        this.fechaHoraControl.reset();
        this.salidaLlegadaControl.reset();
        this.paisUbicacionControl.reset();
        this.C_LOCALIDADControl.reset();
        this.C_LOCALIDAD_ValueControl.reset();
        this.CPUbicacionControl.reset();
        this.estadoUbicacionControl.reset();
        this.municipioUbicacionControl.reset();
        this.CYTI_ID_contol.reset();
        this.coloniaUbicacionControl.reset();
        this.calleUbicacionControl.reset();
        this.numExterioUbicacionControl.reset();
        this.numInteriorUbicacionControl.reset();
        this.referenciaUbicacionControl.reset();
        this.commentsUbicacionesControl.reset();
    }
    resetUbicaciones(){
        this.RFCUbicacionControl.reset();
        this.distanciaRecorridaControl.reset();
        this.fechaHoraControl.reset();
        this.salidaLlegadaControl.reset();
        this.paisUbicacionControl.reset();
        this.C_LOCALIDADControl.reset();
        this.C_LOCALIDAD_ValueControl.reset();
        this.CPUbicacionControl.reset();
        this.estadoUbicacionControl.reset();
        this.municipioUbicacionControl.reset();
        this.CYTI_ID_contol.reset();
        this.coloniaUbicacionControl.reset();
        this.calleUbicacionControl.reset();
        this.numExterioUbicacionControl.reset();
        this.numInteriorUbicacionControl.reset();
        this.referenciaUbicacionControl.reset();
    }
     
    selctionTipoUbicacion(event: any, index: number){
        this.opcionSeleccinada = event.value;
        this.opcionSeleccinadaEdit = event;
        this.lista_ar_company;
        this.lista_company_address;
        this.lista_ar_customer;
        this.lista_customer_address;
        var BILLTYPE = this.dataService.dialogRef._containerInstance._config.data.BILL_TYPE
        const nuevasUbicaciones__company_address = this.lista_company_address.map(element => ({
            id_Ubicaciones: element.COMPANY_ADDRESS_ID,
            value: `Dirección Compañía  ${element.NAME}`
          }));
          
          this.UbicacionesCompañia = [
            { id_Ubicaciones: 0, value: 'Dirección Fiscal Compañía' },
            ...nuevasUbicaciones__company_address
          ];

        const nuevasUbicaciones_ar_customer = this.lista_customer_address.map(element => ({
            id_Ubicaciones: element.CUSTOMER_ADDRESS_ID,
            value: `Dirección Cliente  ${element.NAME}`
          }));

        this.UbicacionesCliente =[{id_Ubicaciones: 0, value: 'Dirección Fiscal Cliente'},
                                    ...nuevasUbicaciones_ar_customer];

        if (BILLTYPE === 'IC') {
            if (this.opcionSeleccinada === 'O' || this.opcionSeleccinadaEdit  === 'O') {
                
            this.distanciaRecorridaControl.disable();
            this.resetUbicacionesALL();
            this.selectUbicaciones = this.UbicacionesCompañia; 
            } else 
            if (this.opcionSeleccinada === 'D' || this.opcionSeleccinadaEdit  === 'D') {
                this.distanciaRecorridaControl.enable();
                this.resetUbicacionesALL();
                this.selectUbicaciones = this.UbicacionesCliente;
            }
        } else if (BILLTYPE === 'T') {
            if (this.opcionSeleccinada === 'O' || this.opcionSeleccinadaEdit  === 'O') {
                this.distanciaRecorridaControl.disable();
                this.resetUbicacionesALL();
                this.selectUbicaciones = this.UbicacionesCompañia;
            } else if (this.opcionSeleccinada === 'D' || this.opcionSeleccinadaEdit  === 'D') {
                this.distanciaRecorridaControl.enable();
                this.resetUbicacionesALL();
                this.selectUbicaciones = this.UbicacionesCompañia;
            }
        }
    }
    seteraUbicaciones(event: any){
        var BILLTYPE = this.dataService.dialogRef._containerInstance._config.data.BILL_TYPE
        this.opcionSeleccinadaEdit ;
        if(BILLTYPE === 'IC'){
            if(this.opcionSeleccinada === 'O' || this.opcionSeleccinadaEdit == 'O'){
                if (event !== undefined && event !== null){
                    if(event.value === 0){
                        this.resetUbicaciones();
                        this.lista_ar_company.forEach(element => {
                            this.RFCUbicacionControl.setValue(element.RFC_UBICACION);
                            this.calleUbicacionControl.setValue(element.CALLE_UBICACION);
                            this.numExterioUbicacionControl.setValue(element.NUM_EXTERIO_UBICACION);
                            this.CPUbicacionControl.setValue(element.CP_UBICACION);
                            this.coloniaUbicacionControl.setValue(element.COLONIA_UBICACION);
                            this.municipioUbicacionControl.setValue(element.MUNICIPIO_UBICACION);
                            this.CYTI_ID_contol.setValue(element.CITY_ID_Ubicaciones);
                            this.estadoUbicacionControl.setValue(element.ESTADO_UBICACION);
                            this.paisUbicacionControl.setValue(element.PAIS_UBICACION);
                            this.C_LOCALIDADControl.setValue(element.LOCATION_ID);
                            this.C_LOCALIDAD_ValueControl.setValue(element.C_LOCALIDAD_Value);
                        });
                    }else{
                        this.resetUbicaciones();
                        const ubicacion = this.lista_company_address.find((element) => element.COMPANY_ADDRESS_ID === event.value);
                        this.calleUbicacionControl.setValue(ubicacion.CALLE_UBICACION);
                        this.RFCUbicacionControl.setValue(ubicacion.RFC_UBICACION);
                        this.numExterioUbicacionControl.setValue(ubicacion.NUM_EXTERIO_UBICACION);
                        this.CPUbicacionControl.setValue(ubicacion.CP_UBICACION);
                        this.coloniaUbicacionControl.setValue(ubicacion.COLONIA_UBICACION);
                        this.municipioUbicacionControl.setValue(ubicacion.MUNICIPIO_UBICACION);
                        this.CYTI_ID_contol.setValue(ubicacion.CITY_ID_Ubicaciones);
                        this.estadoUbicacionControl.setValue(ubicacion.ESTADO_UBICACION);
                        this.paisUbicacionControl.setValue(ubicacion.PAIS_UBICACION);
                        this.C_LOCALIDADControl.setValue(ubicacion.LOCATION_ID);
                        this.C_LOCALIDAD_ValueControl.setValue(ubicacion.C_LOCALIDAD_Value);
                        this.numInteriorUbicacionControl.setValue(ubicacion.NUM_INTERIOR_UBICACION);
                        this.RFCUbicacionControl.setValue(ubicacion.RFC_UBICACION);
                    } 
                }
            }
    
            if (this.opcionSeleccinada === 'D' ||  this.opcionSeleccinadaEdit == 'D'){
                if (event !== undefined && event !== null){
                    if(event.value === 0){
                        this.resetUbicaciones();
                        this.lista_ar_customer.forEach(element => {
                            this.RFCUbicacionControl.setValue(element.RFC_UBICACION);
                            this.calleUbicacionControl.setValue(element.CALLE_UBICACION);
                            this.numExterioUbicacionControl.setValue(element.NUM_EXTERIO_UBICACION);
                            this.CPUbicacionControl.setValue(element.CP_UBICACION);
                            this.coloniaUbicacionControl.setValue(element.COLONIA_UBICACION);
                            this.municipioUbicacionControl.setValue(element.MUNICIPIO_UBICACION);
                            this.CYTI_ID_contol.setValue(element.CITY_ID_Ubicaciones);
                            this.estadoUbicacionControl.setValue(element.ESTADO_UBICACION);
                            this.paisUbicacionControl.setValue(element.PAIS_UBICACION);
                            this.C_LOCALIDADControl.setValue(element.LOCATION_ID);
                            this.C_LOCALIDAD_ValueControl.setValue(element.C_LOCALIDAD_Value);
                        });
                        
                    }else{
                        this.resetUbicaciones();
                        const ubicacion = this.lista_customer_address.find((element) => element.CUSTOMER_ADDRESS_ID === event.value);
                        this.calleUbicacionControl.setValue(ubicacion.CALLE_UBICACION);
                        this.RFCUbicacionControl.setValue(ubicacion.RFC_UBICACION);
                        this.numExterioUbicacionControl.setValue(ubicacion.NUM_EXTERIO_UBICACION);
                        this.CPUbicacionControl.setValue(ubicacion.CP_UBICACION);
                        this.coloniaUbicacionControl.setValue(ubicacion.COLONIA_UBICACION);
                        this.municipioUbicacionControl.setValue(ubicacion.MUNICIPIO_UBICACION);
                        this.CYTI_ID_contol.setValue(ubicacion.CITY_ID_Ubicaciones);
                        this.estadoUbicacionControl.setValue(ubicacion.ESTADO_UBICACION);
                        this.paisUbicacionControl.setValue(ubicacion.PAIS_UBICACION);
                        this.C_LOCALIDADControl.setValue(ubicacion.LOCATION_ID);
                        this.C_LOCALIDAD_ValueControl.setValue(ubicacion.C_LOCALIDAD_Value);
                        this.numInteriorUbicacionControl.setValue(ubicacion.NUM_INTERIOR_UBICACION);
                    } 
                }
            }
        }else if(BILLTYPE === 'T'){
            if (event !== undefined && event !== null){
                if(event.value === 0){
                    this.resetUbicaciones();
                    this.lista_ar_company.forEach(element => {
                        this.RFCUbicacionControl.setValue(element.RFC_UBICACION);
                        this.calleUbicacionControl.setValue(element.CALLE_UBICACION);
                        this.numExterioUbicacionControl.setValue(element.NUM_EXTERIO_UBICACION);
                        this.CPUbicacionControl.setValue(element.CP_UBICACION);
                        this.coloniaUbicacionControl.setValue(element.COLONIA_UBICACION);
                        this.municipioUbicacionControl.setValue(element.MUNICIPIO_UBICACION);
                        this.CYTI_ID_contol.setValue(element.CITY_ID_Ubicaciones);
                        this.estadoUbicacionControl.setValue(element.ESTADO_UBICACION);
                        this.paisUbicacionControl.setValue(element.PAIS_UBICACION);
                        this.C_LOCALIDADControl.setValue(element.LOCATION_ID);
                        this.C_LOCALIDAD_ValueControl.setValue(element.C_LOCALIDAD_Value);
                    });
                }else{
                    this.resetUbicaciones();
                    const ubicacion = this.lista_company_address.find((element) => element.COMPANY_ADDRESS_ID === event.value);
                    this.calleUbicacionControl.setValue(ubicacion.CALLE_UBICACION);
                    this.RFCUbicacionControl.setValue(ubicacion.RFC_UBICACION);
                    this.numExterioUbicacionControl.setValue(ubicacion.NUM_EXTERIO_UBICACION);
                    this.CPUbicacionControl.setValue(ubicacion.CP_UBICACION);
                    this.coloniaUbicacionControl.setValue(ubicacion.COLONIA_UBICACION);
                    this.municipioUbicacionControl.setValue(ubicacion.MUNICIPIO_UBICACION);
                    this.CYTI_ID_contol.setValue(ubicacion.CITY_ID_Ubicaciones);
                    this.estadoUbicacionControl.setValue(ubicacion.ESTADO_UBICACION);
                    this.paisUbicacionControl.setValue(ubicacion.PAIS_UBICACION);
                    this.C_LOCALIDADControl.setValue(ubicacion.LOCATION_ID);
                    this.C_LOCALIDAD_ValueControl.setValue(ubicacion.C_LOCALIDAD_Value);
                    this.numInteriorUbicacionControl.setValue(ubicacion.NUM_INTERIOR_UBICACION);
                } 
            }
        }
    }
    
    camposOrigenDestino(){
        //this.listaCartaPorteDetalle = [];
        this.listaDetalleCartePorte_Ubicacion;
        this.listOrigen;
        this.listDestino;
        this.listaCartaPorteDetalle_U;
        this.listaCartaPorteDetalleUbicaciones;
        var BILL_CARTA_PORTE_ADDRESS_ID = 0
        this.listaDetalleCartePorte_PesoCargaAux;
        
        this.listOrigen = [];
        this.listDestino=[];

            let contadorO = 0;
            let contadorD = 0;
            let Name_origendestino_Aux = ""
            this.listaDetalleCartePorte_PesoCargaAux.forEach((item,i )=> {
                
                this.listaDetalleCartePorte_PesoCargaAux[i].index = i;

                if (item.BILL_CARTA_PORTE_TYPE === "O") {
                    contadorO++;
                    Name_origendestino_Aux = 'OR'  + contadorO.toString().padStart(6, '0');
                    
                }
                if (item.BILL_CARTA_PORTE_TYPE === "D") {
                    contadorD++;
                    Name_origendestino_Aux = 'DE' + contadorD.toString().padStart(6, '0');
                }
                const elemento = {
                  TIPO_UBICACION_opcion: item.BILL_CARTA_PORTE_TYPE,
                  Name_origendestino: Name_origendestino_Aux,
                  id_index:item.index,
                  BILL_CARTA_PORTE_ADDRESS_ID:item.BILL_CARTA_PORTE_ADDRESS_ID
                };
          
                if (item.BILL_CARTA_PORTE_TYPE === "O" && !this.elementoExisteEnLista(elemento, this.listOrigen)) {
                  this.listOrigen.push(elemento);
                } else if (item.BILL_CARTA_PORTE_TYPE === "D" && !this.elementoExisteEnLista(elemento, this.listDestino)) {
                  this.listDestino.push(elemento);
                }
            });

        this.listOrigen;
        this.listDestino;
        if(this.listaDetalleCartePorte_PesoCargaAux.length > 1){
            this.IdOrigenPesoControl.setValue(this.listOrigen[0]['BILL_CARTA_PORTE_ADDRESS_ID']);
             this.IdDestinonPesoControl.setValue(this.listDestino[0]['BILL_CARTA_PORTE_ADDRESS_ID']);
        }
        if(this.editarCartaPorte == false){
            this.validaProductosFactura();
        }
    }

    setValueCartaPorteDetalle(){
        if (this.listaCartaPorteDetallePesoCarga.length > 0) {
            this.listaCartaPorteDetalle = [];
            for (let i = 0; i < this.listaCartaPorteDetallePesoCarga.length; i++) {
                this.listaCartaPorteDetallePesoCarga[i].index = i;
                var origenDetalle = "";
                var destinoDetalle = "";
                const or = this.listOrigen.find((e) => e.BILL_CARTA_PORTE_ADDRESS_ID === this.listaCartaPorteDetallePesoCarga[i]['IdOrigen_DPC']);
                if (or !== null && or !== undefined){
                    origenDetalle = or.Name_origendestino;
                } 
                const des = this.listDestino.find((e) => e.BILL_CARTA_PORTE_ADDRESS_ID === this.listaCartaPorteDetallePesoCarga[i]['IdDestino_DPC']);
                if (des !== null && des !== undefined){
                    destinoDetalle = des.Name_origendestino;
                } 
        
                const modeloAuxiliar: any = {      
                    index: i,
                    BILL_CARTA_PORTE_WEIGHT_DETAIL_ID:  this.listaCartaPorteDetallePesoCarga[i].BILL_CARTA_PORTE_WEIGHT_DETAIL_ID,
                    PRODUCTO_DPC: this.listaCartaPorteDetallePesoCarga[i].PRODUCTO_DPC,
                    UNIDAD_PESO_DPC: this.listaCartaPorteDetallePesoCarga[i].UNIDAD_PESO_DPC,
                    PESO_BRUTO_TOTAL_DPC: this.listaCartaPorteDetallePesoCarga[i].PESO_BRUTO_TOTAL_DPC,
                    PESO_NETO_DPC: this.listaCartaPorteDetallePesoCarga[i].PESO_NETO_DPC,
                    cantidad_DPC: this.listaCartaPorteDetallePesoCarga[i].cantidad_DPC,
                    Cargo_Tasacion_DPC: this.listaCartaPorteDetallePesoCarga[i].Cargo_Tasacion_DPC,
                    ITEM_ID: this.listaCartaPorteDetallePesoCarga[i].ITEM_ID,
                    BILL_UNIT_MEASURE_ID: this.listaCartaPorteDetallePesoCarga[i].BILL_UNIT_MEASURE_ID,
                    satID: this.listaCartaPorteDetallePesoCarga[i].satID,
                    DIMENSIONES_DPC: this.listaCartaPorteDetallePesoCarga[i].DIMENSIONES_DPC,
                    MATERIALPELIGROSO_DPC:this.listaCartaPorteDetallePesoCarga[i].MATERIALPELIGROSO_DPC ,
                    CLAVEMATERIALPELIGROSO_DPC: this.listaCartaPorteDetallePesoCarga[i].CLAVEMATERIALPELIGROSO_DPC,
                    CLAVEMATERIALPELIGROSO_DPC_aux: this.listaCartaPorteDetallePesoCarga[i].HAZARDOUS_MATERIAL,
                    EMBALAJE_DPC:this.listaCartaPorteDetallePesoCarga[i].EMBALAJE_DPC,
                    ITEM_SAT_ID:this.listaCartaPorteDetallePesoCarga[i].ITEM_SAT_ID,
                    BILL_PACKAGING_ID:this.listaCartaPorteDetallePesoCarga[i].BILL_PACKAGING_ID,
                    HAZARDOUS_MATERIAL:this.listaCartaPorteDetallePesoCarga[i].HAZARDOUS_MATERIAL,
                    HAZARDOUS_MATERIAL_ID:this.listaCartaPorteDetallePesoCarga[i].HAZARDOUS_MATERIAL_ID,
                    IdOrigen_DPC:origenDetalle,
                    IdDestino_DPC:destinoDetalle,
                    BILL_CARTA_PORTE_ORI_ADDRESS_ID:this.listaCartaPorteDetallePesoCarga[i].BILL_CARTA_PORTE_ORI_ADDRESS_ID,
                    BILL_CARTA_PORTE_DEST_ADDRESS_ID:this.listaCartaPorteDetallePesoCarga[i].BILL_CARTA_PORTE_DEST_ADDRESS_ID
                };
                this.listaCartaPorteDetalle.push(modeloAuxiliar);   
            }
    
            this.dataSource.data = this.listaCartaPorteDetalle;

            if (this.dataSource.data.length > 0) {
                this.btnSigienteServicios = false;
            }
            
        }else{
            this.dataSource.data= this.listaCartaPorteDetalle = [];
            this.btnSigienteServicios = true;
        }
    }

    private elementoExisteEnLista(elemento: any, lista: any[]): boolean {
        // Verificar si el elemento ya existe en la lista
        return lista.some(item => item.TIPO_UBICACION_opcion === elemento.TIPO_UBICACION_opcion && item.Name_origendestino === elemento.Name_origendestino);
    }
        //-------------------------------------------------------------Trasporte--------------------------------
    setearValueTRS(event: any, index: number){
        if (event !== undefined && event !== null) {        
            const dataChofer = this.listaTransporte.find((element) => element.DRIVER_ID === event.value);
            this.numeroLicenciaControl.setValue(dataChofer.LICENSE_NUMBER);
            this.RFCFiguraControl.setValue(dataChofer.RFC);
            this.CPFiguraTrasporteControl.setValue(dataChofer.CP);
            this.estadoFiguraTrasporteControl.setValue(dataChofer.nombreCyti);
            this.coloniaFiguraTrasporteControl.setValue(dataChofer.SUBURB);
            this.calleFiguraTrasporteControl.setValue(dataChofer.STREET);
            this.numExteriorFiguraTrasporteControl.setValue(dataChofer.OUTDOOR_NUMBER);
            this.numInteriorFiguraTrasporteControl.setValue(dataChofer.INTERIOR_NUMBER);
            this.paisTrasporteControl.setValue(dataChofer.nombrePais);
            this.CITYIDTrasporteControl.setValue(dataChofer.CITY_ID);
            this.municipioFiguraTrasporteControl.setValue(dataChofer.nombreEstado);
            this.referenciaFiguraTrasporteControl.setValue(dataChofer.REFERENCE);
            this.tipoFiguraTrasporteControl.setValue(dataChofer.SAT_FIGURE_TYPE_ID);
            this.tipoFigura_Name_TrasporteControl.setValue(dataChofer.TIPO_Name_TPE);  
        } 
        else{
            this.numeroLicenciaControl.reset();
            this.RFCFiguraControl.reset();
            this.CPFiguraTrasporteControl.reset();
            this.estadoFiguraTrasporteControl.reset();
            this.coloniaFiguraTrasporteControl.reset();
            this.calleFiguraTrasporteControl.reset();
            this.numExteriorFiguraTrasporteControl.reset();
            this.numInteriorFiguraTrasporteControl.reset();
            this.paisTrasporteControl.reset();
            this.CITYIDTrasporteControl.reset();
            this.municipioFiguraTrasporteControl.reset();
            this.tipoFigura_Name_TrasporteControl.reset();

        }
    }
    guardarCartaPorteDetalleHeaderTrasporte(){
        this.edicionBorrar = false;
        this.validarFormularioTrasporte();
        if (this.formularioValido) {
            this.mapearDatosFormControlEnModeloTrasporte();
            this.agregarCartaPorteDetalleTrasporte();
        }
    }
    validarFormularioTrasporte() {
        this.formularioValido = false;
        const campoRequerido = 'Favor de llenar los campos requeridos';
        this.resaltarCamposConErroresTrasporte();
        if (
            this.operadoridControl.invalid ||
            this.numeroLicenciaControl.invalid ||
            this.RFCFiguraControl.invalid ||
            this.paisTrasporteControl.invalid ||
            this.CPFiguraTrasporteControl.invalid ||
            this.municipioFiguraTrasporteControl.invalid ||
            this.estadoFiguraTrasporteControl.invalid ||
            this.coloniaFiguraTrasporteControl.invalid ||
            this.calleFiguraTrasporteControl.invalid ||
            this.numExteriorFiguraTrasporteControl.invalid ||
            this.numInteriorFiguraTrasporteControl.invalid ||
            this.referenciaFiguraTrasporteControl.invalid ||
            this.tipoFiguraTrasporteControl.invalid ||
            this.tipoFigura_Name_TrasporteControl.invalid
        ) {
            this.edicionBorrar = true;
            this._generalService.toastCall(campoRequerido);
            return;
        }
        this.formularioValido = true;
        this.btnGuardar = false;
    }
    resaltarCamposConErroresTrasporte() {
        this.operadoridControl.markAsTouched();
        this.numeroLicenciaControl.markAsTouched();
        this.RFCFiguraControl.markAsTouched();
        this.paisTrasporteControl.markAsTouched();
        this.CPFiguraTrasporteControl.markAsTouched();
        this.municipioFiguraTrasporteControl.markAsTouched();
        this.estadoFiguraTrasporteControl.markAsTouched();
        this.coloniaFiguraTrasporteControl.markAsTouched();
        this.calleFiguraTrasporteControl.markAsTouched();
        this.numExteriorFiguraTrasporteControl.markAsTouched();
        this.numInteriorFiguraTrasporteControl.markAsTouched();
        this.referenciaFiguraTrasporteControl.markAsTouched();
        this.tipoFiguraTrasporteControl.markAsTouched();
        this.tipoFigura_Name_TrasporteControl.markAsTouched();
        
    }
    mapearDatosFormControlEnModeloTrasporte() {

        this.cartaPorteDetalle.DRIVER_ID = this.operadoridControl.value;
         const driver = this.listaTransporte.find((p) => p.DRIVER_ID === this.cartaPorteDetalle.DRIVER_ID); 
         if (driver !== null && driver !== undefined){
            this.cartaPorteDetalle.OPERADOR_T = driver.NAME;
         } 
        this.cartaPorteDetalle.NUMERO_LICENCIA_TPE = this.numeroLicenciaControl.value;
        this.cartaPorteDetalle.RFC_FIGURA_TPE = this.RFCFiguraControl.value;
        this.cartaPorteDetalle.PAIS_TPE = this.paisTrasporteControl.value;
        this.cartaPorteDetalle.CITY_ID_TPE = this.CITYIDTrasporteControl.value;
        this.cartaPorteDetalle.CP_FIGURA_TPE = this.CPFiguraTrasporteControl.value;
        this.cartaPorteDetalle.MUNICIPI_TPE = this.municipioFiguraTrasporteControl.value;
        this.cartaPorteDetalle.ESTADO_TPE = this.estadoFiguraTrasporteControl.value;
        this.cartaPorteDetalle.COLONIA_TPE = this.coloniaFiguraTrasporteControl.value;
        this.cartaPorteDetalle.CALLE_TPE = this.calleFiguraTrasporteControl.value;
        this.cartaPorteDetalle.NUM_EXTERIOR_TPE = this.numExteriorFiguraTrasporteControl.value;
        this.cartaPorteDetalle.NUM_INTERIOR_TPE = this.numInteriorFiguraTrasporteControl.value;
        this.cartaPorteDetalle.REFERENCIA_TPE = this.referenciaFiguraTrasporteControl.value;
        this.cartaPorteDetalle.TIPO_TPE = this.tipoFiguraTrasporteControl.value;
        this.cartaPorteDetalle.TIPO_Name_TPE= this.tipoFigura_Name_TrasporteControl . value  
    }
    agregarCartaPorteDetalleTrasporte() {

        let index = 0;
        this.listaDetalleCartePorte_Trasporte = this.listaCartaPorteDetalleTrasporte;
        if (this.listaDetalleCartePorte_Trasporte.length === 0) {
             index = 0;
        } else {
             index = this.listaDetalleCartePorte_Trasporte.length;
        }
        this.cartaPorteDetalle.index = index;
        this.listaDetalleCartePorte_Trasporte[index] = this.cartaPorteDetalle;
        this.listaCartaPorteDetalle = this.listaDetalleCartePorte_Trasporte;
        this.seEstaEditando3 = false;
        setTimeout( () => {
            this.dataSource03.data = this.listaCartaPorteDetalle;
            this.establecerValoresPorDefectosTrasporte();
        });  
    }
    establecerValoresPorDefectosTrasporte() {
        this.seEstaEditando3 = false;
        this.seEstaAgregandoTraporte = false;
        this.operadoridControl.reset();
        this.numeroLicenciaControl.reset();
        this.RFCFiguraControl.reset();
        this.paisTrasporteControl.reset();
        this.CITYIDTrasporteControl.reset();
        this.CPFiguraTrasporteControl.reset();
        this.municipioFiguraTrasporteControl.reset();
        this.estadoFiguraTrasporteControl.reset();
        this.coloniaFiguraTrasporteControl.reset();
        this.calleFiguraTrasporteControl.reset();
        this.numExteriorFiguraTrasporteControl.reset();
        this.numInteriorFiguraTrasporteControl.reset();
        this.referenciaFiguraTrasporteControl.reset();
        this.tipoFiguraTrasporteControl.reset();
        this.tipoFigura_Name_TrasporteControl.reset();
    }
    eliminarRowTrasporte(element3){

        const index = this.listaCartaPorteDetalle_T.findIndex((obj) => obj.index === element3.index);
        if (element3.BILL_CARTA_PORTE_DRIVER_ID !== null && element3.BILL_CARTA_PORTE_DRIVER_ID !== undefined) {
            
            this.eliminarDetalleTrasporte(this.listaCartaPorteDetalle_T[index]);
        } else {
            this.eliminarTrasporte(element3.index);
        }
       
        if (this.dataSource03.data.length == 0) {
            this.btnGuardar = true;
        }
    }
    eliminarTrasporte(id) {
        const index = this.listaCartaPorteDetalle_T.findIndex((element3) => element3.index === id);
        this.listaCartaPorteDetalle_T.splice(index, 1);
        this.listaCartaPorteAgregar.splice(index, 1);
        setTimeout( () => {
            this.dataSource03.data = this.listaCartaPorteDetalle_T;
        });
    }
    establecerDetalleTrasporte(cartaPorteDetalle: CartaPorteDetalle){
        this.cartaPorteDetalle = new CartaPorteDetalle();
        this.seEstaEditando3 = true;
  
        this.cartaPorteDetalle = cartaPorteDetalle;
        this.transaccionEnCurso = true;
        this.operadoridControl.setValue(cartaPorteDetalle.DRIVER_ID);
        this.numeroLicenciaControl.setValue(cartaPorteDetalle.NUMERO_LICENCIA_TPE);
        this.RFCFiguraControl.setValue(cartaPorteDetalle.RFC_FIGURA_TPE);
        this.paisTrasporteControl.setValue(cartaPorteDetalle.PAIS_TPE);
        this.CPFiguraTrasporteControl.setValue(cartaPorteDetalle.CP_FIGURA_TPE);
        this.CITYIDTrasporteControl.setValue(cartaPorteDetalle.CITY_ID_TPE);
        this.municipioFiguraTrasporteControl.setValue(cartaPorteDetalle.MUNICIPI_TPE);
        this.estadoFiguraTrasporteControl.setValue(cartaPorteDetalle.ESTADO_TPE);
        this.coloniaFiguraTrasporteControl.setValue(cartaPorteDetalle.COLONIA_TPE);
        this.calleFiguraTrasporteControl.setValue(cartaPorteDetalle.CALLE_TPE);
        this.numExteriorFiguraTrasporteControl.setValue(cartaPorteDetalle.NUM_EXTERIOR_TPE);
        this.numInteriorFiguraTrasporteControl.setValue(cartaPorteDetalle.NUM_INTERIOR_TPE);
        this.referenciaFiguraTrasporteControl.setValue(cartaPorteDetalle.REFERENCIA_TPE);
        this.tipoFiguraTrasporteControl.setValue(cartaPorteDetalle.TIPO_TPE);
        this.tipoFigura_Name_TrasporteControl.setValue(cartaPorteDetalle.TIPO_Name_TPE);
        this.transaccionEnCurso = false;
    }
    guardarCartaPorteDetalleRowTrasporte(){
        this.validarFormularioTrasporte();
        if (this.formularioValido) {
            this.mapearDatosFormControlEnModeloTrasporte();
            this.editarFacturaDetalleTrasporte();
        }
    }
    editarFacturaDetalleTrasporte() {
        var index: any = 0;
        this.listaDetalleCartePorte_Trasporte = this.listaCartaPorteDetalleTrasporte;
        this.listaDetalleCartePorte_Trasporte.forEach(element => {
        if(element.index == this.cartaPorteDetalle.index){
            index = element.index;
            return;
        }
        });

        this.cartaPorteDetalle.index = index;
        this.listaDetalleCartePorte_Trasporte[index] = this.cartaPorteDetalle;
    
        this.listaCartaPorteDetalle_T = this.listaDetalleCartePorte_Trasporte;
        this.seEstaEditando3 = false;
        setTimeout( () => {
          this.dataSource03.data = this.listaCartaPorteDetalle_T;
         
        });
    }

    eliminarDetalleTrasporte(cartaPorteDetalle: CartaPorteDetalle){
        const metodo = 'factura/deleteDetalleCartaPorte';
        this._generalService.metodoCallParams(cartaPorteDetalle, metodo).subscribe(
            (result) => {
                this._generalService.toastCall('Se ha eliminado el renglon exitosamente!');
                this.getCartaPorteDetalle(this.dataSource03);
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );

    }




    
 
   
}



// WEBPACK FOOTER //
// ./src/app/factura/cartaPorte/carta-porte.component.ts